import {
  AMOUNT_GT_0_ERR, CLAIMSUBMISSION_MESSAGE, POLICYNO_REGEX, POLICY_NO_REGEX, YEAR_0_ERR,
  SETTLEMENT_DOD_ERR_MSG, PAN_CARD_NUMBER_ERROR_MESSAGE, PANCARD_REGEX, LENGTHOFSTAY_INLINE_ERR_MSG,
  GHI_VALIDATION_REGEX, ABHI_MEMBER_SEARCH_ERR_MSG,
  ABHI_MEMBER_SEARCH_VALIDATION_MESSAGE, HYPHEN_REGEX, DOADOD_DAYCARE_ERR_MSG,
  VOTER_ID_ERROR_MESSAGE, VOTER_ID, MONTH_FORMAT_ERROR, YEAR_FORMAT_ERROR, NUMBER_INPUT_ERR_MSG,
  MEMBER_ID_NUMERICAL_REGEX, POLICY_NO_REGEX_SPCL_CHARACTER, POLICY_SEARCH_MESSAGE,
  VALID_NUMBER_ERR_MSG, DEATHCASE_DOD_ERR_MSG, NAME_REGEX, CHOLA_POLICY_NUMBER_PATTERN, SPCL_CHARACTER,
  ALPHA_NUMERIC_REGEX,
  ALPHA_NUMERIC_VALIDATION,
  AMOUNT_MAXLIMIT_ERR,
  VALID_MONTH_PATTERN,
  VALID_YEAR_PATTERN,
  DATE_FILTER,
  DEFAULT_TEXT,
  CONFIGURATION_VALIDATIONS,
  EMAIL_REGX,
  CASHLESS_FORM_CONSTANTS,
  APPLICATION_ID_2,
  INVENTROY_CONSTANTS,
  PATIENT_SIGNATURE_CONSTANTS,
  INPATIENT_FILTER_TITLE_MAP,
  DATE_FORMAT_TO_PARSE,
  PAYER_NOT_CONFIGURED_ERR,
  CANCELLATION_SUCCESSFUL_MESSAGE,
  CANCELLATION_FAILURE_MESSAGE,
  ONLY_ALPHABET,
  SINCE_WHEN_NUMBERS_AND_SPACES_REGEX,
  AADHAR_CARD_REGEX, COMMON_DATE_FORMAT, DOADOD_INLINE_ERR_MSG,
  HEALTH_ADDRESS_REGEX, HEALTH_ID_ERROR_MESSAGE, HEALTH_ID_REGEX,
} from '../../../../shared/constants/commonConstants';
import * as moment from 'moment';
import {
  actions, ACTION_ADMISSION_SUBMIT, ACTION_CORPORATE_EDIT,
  ACTION_REIMBURSEMENT, ADMISSION_FORM_TYPES, BILL_DETAIL, BILL_DETAIL_HDFC, CATARACT_LENS_TYPE,
  CATARACT_TYPE,
  defaultProdDiagnosis,
  DEFAULT_PROD_DIAGNOSIS_ICDS,
  DETAIL_NAV,
  DIALYSIS_DIAGNOSIS_TYPE,
  IN_PATIENT_PAGE_NAME, MATERNITY_TYPE, MAX_NUMBERS_OF_IP_COLS, MAX_NUMBERS_OF_CLAIMS_DISPLAY_COLS,
  MIN_NUMBERS_OF_IP_COLS, MIN_NUMBERS_OF_CLAIMS_DISPLAY_COLS, NEW_ADMISSION_FORM_KEY,
  NEW_DETAIL_NAV, NEW_DETAIL_NAV_NO_BENEF, OTHERTHEN_DISCHARGE,
  OTHER_ID,
  policyGroups,
  PROCEDURE_OTHER_TYPES,
  RPA_BILL_DETAIL,
  PROGRESS_COLOR_GRAY,
  PROGRESS_COLOR_GREEN,
  BILL_DETAIL_EMAIL,
  HIS_NEW_DESIGN_DOCUMENT_UPLOAD_FLOW,
  NON_HIS_NEW_DESIGN_DOCUMENT_UPLOAD_FLOW,
  OLD_DOCUMENT_UPLOAD_FLOW,
  RECONSIDERATION_REQUEST_STATUS,
  DEFAULT_VISIT_CODE,
  HISParams,
  HISPayload,
  HIS_CONFIG,
  GENDER_OPTIONS,
  OTHER_GENDER_OPTIONS,
  VALUE_NOT_UPDATED,
  DATE_DROPDOWN_MODELIING,
  MDI_MEMBERID_VALID_MESSAGE,
  MDI_MEMEBERID_REGEX,
  BENEFICIARY_SEARCH_OPTION,
  BENEFICIARY_SEARCH_OPTION_MDI,
  BENEF_RETRY_MESSAGE,
  MDI_MEMBERID_PREFIX,
  EXTENTION_KEYS,
  INPATIENT_TEXT_MAPPING,
  DATEPICKER_ERROR_MESSAGE,
  DRAFT_KEYS,
  ctaActionNames,
  BENEF_NOT_FOUND_MESSAGE,
  BENEF_PRIMARY_KEY_MAP,
  PAYLOAD_TO_IHAVE,
  DOCTOR_NAME_REGEX,
  PREFIXES,
  DYNAMIC_FIELD_MAPPINGS,
  OTHER_INJURY_REASON_OPTIONS,
  HIS_ADDITIONAL_ATTRIBUTES_MAP_TYPE,
  ORION_PRODUCT_CODE_ARTEMIS,
  ORION_PRODUCT_CODE_FT,
} from '../../../../shared/constants/crmConstants';
import { AdmissionForm } from '../../../../store/models/newAdmissionModel';
import { cloneDeep, differenceBy, get, intersection, intersectionWith, isEmpty, uniqBy } from 'lodash';
import { getDateDurationInHours, getDateWithTime, isDateLessThenToday } from '../../../../utils/dateTimeUtils';
import { UploadFile } from 'antd/lib/upload/interface';
import ApplicationDetail from '../../../../shared/services/applicationDetail.service';
import { base64UrlEncode, centeredNotification, formatName, getMobileFormat, replaceRsAndComma, replaceUnderscoreAndDot } from '../../../../utils/utility';
import { Payer } from '../../../../shared/models/payer.model';
import { IPayerExtension } from '../../../../store/models/utilModels';
import { GLOBAL_URL } from '../../../../shared/constants/dataServiceUrl';
import { parse, format, isWithinInterval, isBefore, subDays, differenceInMinutes, isValid } from 'date-fns';
import HISDataToClaimForm from '../../../../config/HISDataToClaimForm.json';
import { ReactElement } from 'react';
import { FormInstance } from 'antd/lib/form';
import {
  ClassificationItem, DraftItem, Letter,
  PatientDetail, PayerConfig, ExtensionField,
  BeneficiaryDetail, Doctor,
  HISPrefillParseType,
} from '../../../../shared/interfaces/newAdmissionInterface';
import { BillItem } from '../../../../shared/models/inPatient.model';

export const getValueFromID = (id: any, array: any[] = [], additionalFieldToShare?: string): string => {
  const searchedObj = array?.find(({ masterLookId }: any): any => parseInt(masterLookId, 10) === parseInt(id, 10));
  return searchedObj?.[additionalFieldToShare || 'name'] || id;
};

export const updateAdmissionFormValue = ({
  memberName: fullName, policyNo: policyNumber, memberId, insuranceCompanyName,
  policyHolderName: corporateName, employeeCode, memberGenderSex, memberRelation: relation, memberRelation: relationTextInput, memberAge,
  memberGenderSexRadio, dateOfBirth, mobile, aadharNo, employeeName, payerId, productCode, pehchanNo, certificateNumber,
  policyHolderName: corporateNameDropdown, unitName,
}: any, formVal: AdmissionForm, insurerNameLookUp: any[] = [], { patientDetails }: any = {}): AdmissionForm => {
  const [customerKey] = NEW_ADMISSION_FORM_KEY;
  const insurerDetail = insurerNameLookUp.find((obj: any): boolean => obj.name === insuranceCompanyName);
  const formattedAadhar = aadharNo?.match(AADHAR_CARD_REGEX)?.join(' ') || aadharNo;
  const hospitalNumber = patientDetails?.registrationNumber;
  const memberGender = memberGenderSexRadio || patientDetails?.memberGender;

  // converting '9999999999' to '+91 999 9999 999'
  const formattedNumber = mobile ? `+91 ${mobile.slice(0, 3)} ${mobile.slice(3, 7)} ${mobile.slice(7)}` : '';

  const newCustomerDetail = {
    memberId,
    corporateName,
    fullName,
    policyNumber,
    insurerName: insurerDetail?.value || insuranceCompanyName,
    employeeId: employeeCode,
    memberGenderSex: memberGender,
    relation,
    relationTextInput,
    memberAge: memberAge || patientDetails?.memberAge,
    aadharNo: formattedAadhar,
    employeeName,
    payerId,
    productCode,
    memberGenderSexRadio: memberGender,
    dateOfBirth: dateOfBirth ? moment.default(dateOfBirth) : null,
    pehchanNo,
    mobile: formattedNumber,
    certificateNumber,
    corporateNameDropdown,
    hospitalNumber,
    unitName,
    // TODO: Don't remove emailId. Cause of multiple email issue. Comment the line.
    // emailId,
  };
  const customerDetail = { ...(formVal as any)[customerKey], ...newCustomerDetail };

  return { ...formVal, ...{ customerDetail } };
};

export const fileUploadCheck = (pathname: string, uploadedFiles: any[]): boolean => {
  if (getIsPageNameDetail(pathname)) {
    return true;
  } else if (getIsPageNameEdit(pathname) || getIsPageNameEditDischarge(pathname) || getIsPageNameReconsider(pathname)) {
    const filteredAttachment = getValidUploadedFiles(uploadedFiles);
    return filteredAttachment && filteredAttachment.length > 0;
  } else {
    return uploadedFiles && uploadedFiles.length > 0; // TODO: make change here
  }
};

export const prepareAttachment = (attachments: any[], lookUpObj: any[] = []): any[] => {
  return attachments
    .filter(({ response, existingRecord }: any): boolean => response && response.isSuccess && existingRecord ? true : !existingRecord)
    .map((file: any): any => {
      const { response, fileType } = file;
      const { uploadedDetails: [{ fileName = '', fileGuid: filePath }] } = response;
      return {
        fileName,
        filePath,
        fileType: getFilteredLookUpBasedOnName(fileType || [], lookUpObj, true),
      };
    });
};

export function calculateBillAmount(noOfDays: number, dialysis: any, is_Per_Day_Eligible_Package: boolean, packageCost: number,
  packageName: any): number {
  const dialysisPackage = (packageName?.toLowerCase()?.includes('dialysis'));
  if (dialysis && dialysisPackage) {
    return parseInt(dialysis, 10) * packageCost;
  }
  if (is_Per_Day_Eligible_Package) {
    return noOfDays * packageCost;
  }
  return packageCost;
}

export const prepareBillDetail = (bills: any, selectedPackage: any[] = [], dialysis?: string,
  dateOfAdmission?: moment.Moment, dateOfDischarge?: moment.Moment, payer?: Payer, collapsibleBillSection?: boolean): any[] => {
  const { isRpaPayer, shortName, isOnMailPayer, isRPAOutboundDisabledPayer } = payer || {};
  const noOfDays = getNoOfDays(dateOfAdmission, dateOfDischarge);
  const BILLDETAILS = (shortName === 'HDFC' && process.env.REACT_APP_HDFC_FEATURES === 'true') ? BILL_DETAIL_HDFC : BILL_DETAIL;
  const packageObject = BILLDETAILS[0];
  const indexToCompare = selectedPackage.length ? 1 : 0;
  const packageArray = selectedPackage.map(({ packageId, name, packageCost, is_Per_Day_Eligible_Package }: any): any => ({
    ...packageObject,
    billPackageId: !isNaN(packageId) ? parseInt(packageId, 10) : packageId,
    billPackageName: name,
    billAmount: calculateBillAmount(noOfDays, dialysis, is_Per_Day_Eligible_Package, packageCost, name), is_Per_Day_Eligible_Package,
  }),
  );

  const billWithoutPackage = (isRpaPayer ? RPA_BILL_DETAIL : (isOnMailPayer || isRPAOutboundDisabledPayer ||
    collapsibleBillSection) ? BILL_DETAIL_EMAIL
    : BILLDETAILS)
    ?.filter((bill: any, index: number): boolean => index >= indexToCompare && bills?.[bill?.billPackageName])
    ?.map((bill: any): any => ({
      ...bill,
      billAmount: parseInt(String(bills[bill?.billPackageName]).replace(/[₹ ,]/g, ''), 10),
    }))
    .filter(({ billAmount }: any): boolean => billAmount !== 0);
  return packageArray?.concat(billWithoutPackage);
};

export const getTotalClaimAmount = (billDetail: any[]): number => {
  return billDetail.reduce((total: number, { billAmount }: any): number => total + billAmount, 0);
};

export const getLookUpFullDetail = (
  lookUpIds: any[] = [], lookUpObj: any[] = [], isPayer: boolean,
  removeDefault: boolean = false): any[] => {
  return (!Array.isArray(lookUpIds)) ? [] : lookUpIds?.map((id: any): any => {
    const findObj = lookUpObj?.find((obj: any): any => obj.value === id || obj.payerMasterValue === id || obj?.name === id);
    if (findObj) {
      return findObj;
    } else {
      if (!removeDefault) {
        return (isPayer ? { payerMasterValue: id, masterLookId: -1 } : { id: -1, name: id });
      }
    }
  });
};

export const getPayerLookUpDetail = (
  treatmentIds: any[] = [], PayerLookObj: any[] = []): any[] => {
  return treatmentIds.map((id: any): any => {
    const findObj = PayerLookObj.find((ele: any): any => ele.value === id);
    if (findObj) {
      return findObj;
    }
  });
};

export const getFilteredLookUpBasedOnName = (lookUpNames: any[] = [], lookUpObj: any[] = [], isPayer: boolean): any[] => {
  return lookUpNames.map((name: any): any => {
    const findObj = lookUpObj.find(
      ({ payerMasterValue, name: masterName }: any): any => (payerMasterValue === name) || (masterName === name),
    );
    return findObj || (isPayer ? { payerMasterValue: name, masterLookId: -1 } : {
      id: -1,
      name,
    });
  });
};

export const accidentExtension = (treatmentDetail: any): any => {
  const {
    isItARta, dateOfInjury, isReportedToPolice, firNumber, injuryOrDeseaseCaused,
    testConductedToEstablishedThis, accidentDueTo, reasonForInjury, dateOfCommencement,
  } = treatmentDetail || {};
  const isMLC = treatmentDetail?.[0] === 'Yes' ? true : false;
  const permanentDisability = treatmentDetail?.permanentDisability?.[0] === 'Yes' ? true : false;
  const property: any[] = [];
  validateAndUpdateExtension(dateOfInjury, 'dateOfInjury', property);
  validateAndUpdateExtension(isReportedToPolice, 'isReportedToPolice', property);
  validateAndUpdateExtension(firNumber, 'firNumber', property);
  validateAndUpdateExtension(injuryOrDeseaseCaused, 'injuryOrDeseaseCaused', property);
  validateAndUpdateExtension(testConductedToEstablishedThis, 'testConductedToEstablishedThis', property);
  validateAndUpdateExtension(isItARta, 'isItARta', property);
  validateAndUpdateExtension(accidentDueTo, 'accidentDueTo', property);
  validateAndUpdateExtension(reasonForInjury, 'reasonForInjury', property);
  validateAndUpdateExtension(isMLC, 'isMLC', property);
  validateAndUpdateExtension(permanentDisability, 'permanentDisability', property);
  validateAndUpdateExtension(dateOfCommencement, 'dateOfCommencement', property);
  return property;
};
export const covidExtension = (treatmentDetail: any): any => {
  const {
    sinceFeverDays, oxygenSaturationLevel, respiratoryRate,
  } = treatmentDetail || {};
  const property: any[] = [];
  validateAndUpdateExtension(sinceFeverDays, 'sinceFeverDays', property);
  validateAndUpdateExtension(oxygenSaturationLevel, 'oxygenSaturationLevel', property);
  validateAndUpdateExtension(respiratoryRate, 'respiratoryRate', property);
  return property;
};

export const getMaternityType = (deliveryType: number): any => {
  return MATERNITY_TYPE.find(({ value }: any): boolean => value === deliveryType);
};

export const maternityExtension = (treatmentDetail: any): any => {
  const { obstetricHistoryG, obstetricHistoryP, obstetricHistoryL, obstetricHistoryA, obstetricHistoryD,
    deliveryDate, maternityType, noOfAdoptedChildren, noOfDeliveries, noOfBiologicalChildren, typeOfMaternity,
    lmp, dobOfChild, vaccinationDate, typeOfDelivery } = treatmentDetail || {};
  const property: any[] = [];
  let ailmentCode;
  if (maternityType) {
    const { code } = getMaternityType(maternityType);
    ailmentCode = code;
  }
  validateAndUpdateExtension(obstetricHistoryG, 'obstetricHistoryG', property);
  validateAndUpdateExtension(obstetricHistoryP, 'obstetricHistoryP', property);
  validateAndUpdateExtension(obstetricHistoryL, 'obstetricHistoryL', property);
  validateAndUpdateExtension(obstetricHistoryA, 'obstetricHistoryA', property);
  validateAndUpdateExtension(obstetricHistoryD, 'obstetricHistoryD', property);
  validateAndUpdateExtension(deliveryDate, 'deliveryDate', property);
  validateAndUpdateExtension(ailmentCode, 'ailmentcode', property);
  validateAndUpdateExtension(maternityType, 'ailmentid', property);
  validateAndUpdateExtension(noOfAdoptedChildren, 'noOfAdoptedChildren', property);
  validateAndUpdateExtension(noOfDeliveries, 'noOfDeliveries', property);
  validateAndUpdateExtension(noOfBiologicalChildren, 'noOfBiologicalChildren', property);
  validateAndUpdateExtension(typeOfMaternity, 'typeOfMaternity', property);
  validateAndUpdateExtension(lmp, 'lmp', property);
  validateAndUpdateExtension(dobOfChild, 'dobOfChild', property);
  validateAndUpdateExtension(vaccinationDate, 'vaccinationDate', property);
  validateAndUpdateExtension(typeOfDelivery, 'typeOfDelivery', property);
  return property;
};

export const getCataractType = (cataractId: number): any => {
  return CATARACT_TYPE.find(({ value }: any): boolean => value === cataractId);
};

export const cataractExtension = (treatmentDetail: any): any[] => {
  const { cataractType: cataractId, contactLensType } = treatmentDetail || {};
  let cataractCode;
  if (cataractId) {
    const { code }: any = getCataractType(cataractId);
    cataractCode = code;
  }
  const property: any[] = [];
  validateAndUpdateExtension(cataractCode, 'ailmentcode', property);
  validateAndUpdateExtension(cataractId, 'ailmentid', property);
  validateAndUpdateExtension(contactLensType, 'lenseId', property);

  return property;
};
export const claimsDisplayMappingColumns: any = {
  inPatientNo: 'IP No.',
  memberId: 'Member Id',
  policyNo: 'Policy No',
  payerClaimNo: 'Claim No',
  patientName: 'Patient Name',
  payerId: 'Payer',
  insurerName: 'Insurer Name',
  claimedAmount: 'Claimed Amount',
  approvedAmount: 'Approved Amount',
  statusId: 'Status',
  doa: 'DOA',
  dod: 'DOD',
  modifiedOn: 'Last Modified Date',
  createdOn: 'Claim Creation Date',
  uhid: 'UHID',
};

const dateKeys = ['doa', 'dod', 'modifiedOn', 'createdOn'];

// Function to get the title based on the key
export const getTitle = (key: string): string => {
  return claimsDisplayMappingColumns[key] || key;
};

// Function to create a map from payerId to shortName
const createPayerShortNameMap = (payers: any[]): { [key: string]: string } => {
  return (Array?.isArray(payers) ? payers : [])?.reduce(
    (map: any, payer: any): any => {
      map[payer?.uniqueIdentifier] = payer?.shortName;
      return map;
    },
    {},
  );
};

// Function to create a map from status key to value
const createStatusMap = (statusArray: any[]): { [key: string]: string } => {
  return (Array?.isArray(statusArray) ? statusArray : [])?.reduce(
    (map: any, status: any): any => {
      map[status?.key] = status?.value;
      return map;
    },
    {},
  );
};

// Function to format date range
const formatDateRange = (dateStr: string | undefined): string => {
  if (!dateStr) {
    return '';
  }
  const dates = dateStr
    ?.split(',')
    ?.map((date: any): any => new Date(date?.trim()));
  const formatDate = (date: Date): string => {
    const day = date?.getDate()?.toString()?.padStart(2, '0');
    const month = (date?.getMonth() + 1)?.toString()?.padStart(2, '0'); // Months are zero-indexed
    const year = date?.getFullYear();
    return `${day}-${month}-${year}`;
  };

  return dates?.map((date: any): any => formatDate(date))?.join(' to ');
};

// Function to format number with hyphen
const formatNumber = (value: string | undefined): string => {
  return value?.replace(/,/g, ' - ') || '';
};

// Function to concatenate values
export const concatenateValues = (
  data: any,
  payers: any[] = [],
  statusArray: any[] = [],
  globalSearch?: { key: string; value: string},
): string => {
  const payerMap = createPayerShortNameMap(payers);
  const statusMap = createStatusMap(statusArray);
  if (globalSearch?.value) {
    return `Global Search for ${(INPATIENT_TEXT_MAPPING as any)[globalSearch?.key]}: <b>${globalSearch?.value || '-'}</b>`;
  } else {
  return Object.keys(data)
    ?.filter(
      (key: any): any =>
        data[key] !== undefined &&
        data[key] !== null &&
        (Array?.isArray(data[key])
          ? data[key]?.some((item: any): any => item !== '')
          : data[key]?.toString()?.trim() !== ''),
    )
    ?.map((key: any): any => {
      const title = INPATIENT_FILTER_TITLE_MAP[key] || getTitle(key);
      let value = Array.isArray(data?.[key]) ? data?.[key]?.join(',') : data?.[key];

      switch (key) {
        case 'payerId':
          value = value
            ?.split(',')
            ?.map((id: any): any => payerMap[id] || id)
            .join(' / ');
          break;
        case 'insurerName':
          value = value?.split(',').join(' / ');
          break;
        case 'statusId':
          value = value
            ?.split(',')
            ?.map((id: any): any => statusMap[id] || id)
            .join(' / ');
          break;
        case 'claimedAmount':
        case 'approvedAmount':
          value = formatNumber(value);
          break;
        case 'dateFilter':
        case 'elapsedTime':
          value = value?.split(',').join(', ');
          break;
        default:
          if (dateKeys?.includes(key)) {
            value = formatDateRange(value);
          }
          break;
      }
      return `${title}: <b>${value || '-'}</b>`;
    })
    .join(' + ');
  }
};

export const otherTreatmentDetailExtension = (treatmentDetail: any): any[] => {
  const { dialysis, eye, treatmentApproach, position, admissionType, rpaAdmissionType, speciality = null, lossType,
    dateOfDiagnosis } = treatmentDetail || {};
  const property: any[] = [];
  validateAndUpdateExtension(dialysis, 'dialysis', property);
  validateAndUpdateExtension(eye, 'eye', property);
  validateAndUpdateExtension(treatmentApproach, 'treatmentApproach', property);
  validateAndUpdateExtension(position, 'position', property);
  validateAndUpdateExtension((admissionType || rpaAdmissionType), 'admissionType', property);
  validateAndUpdateExtension(lossType, 'lossType', property);
  validateAndUpdateExtension(dateOfDiagnosis ? moment?.default(dateOfDiagnosis)?.format('YYYY-MM-DD') : null, 'dateOfDiagnosis', property);
  validateAndUpdateExtension(speciality, 'speciality', property);
  if (dialysis) {
    validateAndUpdateExtension(DIALYSIS_DIAGNOSIS_TYPE[0], 'ailmentcode', property);
  }

  return property;
};

export const otherFormTreatmentDetailExtension = (otherFormDetail: any): any[] => {
  const { admissionType } = otherFormDetail || {};
  const property: any[] = [];
  validateAndUpdateExtension((admissionType), 'admissionType', property);
  return property;
};

export const validateAndUpdateExtension = (field: any, fieldKeyName: string, arrToStore: any[]): any => {
  if (field === null || field === undefined) {
    return;
  }
  if (moment.isMoment(field) || field instanceof Date) {
    arrToStore.push({
      fieldName: fieldKeyName,
      fieldValue: moment.default(field).format(),
    });
  } else if (typeof field === 'string') {
    arrToStore.push({
      fieldName: fieldKeyName,
      fieldValue: field,
    });
  } else {
    arrToStore.push({
      fieldName: fieldKeyName,
      fieldValue: JSON.stringify(field),
    });
  }
};

export const prepareClassifications = (classificationArr: any[], uploadedFiles: any[]): any[] => {
  const trueClassifications = uploadedFiles.map(({ fileType, documentTypes, transactionId, lastModifiedDate, name,
    response: { uploadedDetails } }: any): any => ({
      availableDocumentType: fileType === null ? '' : JSON.stringify(fileType),
      fileId: getValue(uploadedDetails, '[0].fileGuid'),
      fileName: name,
      answerOn: lastModifiedDate,
      documentTypes,
      transactionId,
      attemptId: '1',
      isDeleted: false,
      discrepancy: false,
      isRejected: false,
    }));
  const filteredClassification = classificationArr?.filter(({ answer }: any): boolean => answer !== null);
  const missedClassification = differenceBy(trueClassifications, filteredClassification, 'fileId');
  return filteredClassification?.concat(missedClassification)?.map((ele: any): any => { // added null check
    delete ele['tempId'];
    return ele;
  });
};

export const otherMemberDetailExtension = (otherMemberDetail: any): any => {
  const otherMemberDetailArr: any[] = [];
  const { district, aadharNo, designation, relation, unitName, employeeName, placeOfPosting, urn, corporate_name,
    draftCaseUrn } =
    otherMemberDetail || {};
  const benefSearchUrn = urn || draftCaseUrn; // handling draft cases
  validateAndUpdateExtension(district, 'district', otherMemberDetailArr);
  validateAndUpdateExtension(aadharNo, 'aadharNo', otherMemberDetailArr);
  validateAndUpdateExtension(designation, 'designation', otherMemberDetailArr);
  validateAndUpdateExtension(relation, 'relation', otherMemberDetailArr);
  validateAndUpdateExtension(corporate_name, 'corporate_name', otherMemberDetailArr);
  validateAndUpdateExtension(unitName, 'unitName', otherMemberDetailArr);
  validateAndUpdateExtension(employeeName, 'employeename', otherMemberDetailArr);
  validateAndUpdateExtension(placeOfPosting, 'placeOfPosting', otherMemberDetailArr);
  validateAndUpdateExtension(benefSearchUrn, 'urn', otherMemberDetailArr);
  return otherMemberDetailArr;
};

// for replacing empty string
export const replaceEmptyStringWithUndefined = (obj: any): any => {
  for (const key in obj) {
    if (typeof obj[key] === 'object' && obj[key] !== null && obj[key] !== '') {
      replaceEmptyStringWithUndefined(obj[key]);
    } else if (obj[key] === '') {
      obj[key] = undefined;
    }
  }
};

export const prepareExtension = (props: IPayerExtension): any[] => {
  const {
    treatmentDetail = {}, isRulesConfigured, ailmetPastHistory, isDeathCase, isDischargeCase, memberSearchFailed, isCovidCase,
    sinceYearDate, otherFormDetail = {},
    isMultipleSurgeries, otherMemberDetail = {}, remarks = {}, ProcdureDescAutomation, additionalAdmissionInfo,
    doctorQualification, doctorMobileNo, doctorSpecialization, newPackageName,
    hospitalNumber, courierTrackId, courierProvider, isDocChecklistVerified, dateOfBirth, policyEndDate, policyStartDate,
    insuranceCardNumber, policyType, pehchanNo,
    roomType = null, hospitalRoomType = null, additionalEmails, action, routeOfAdministration, presentComplaints,
    retailOrCorporate, kycpan, kycAdhaar, pastHistoryOfPresentAilment, switchClick, drivingLicense, voterId,
    patientID, ailmentAsPerUser, beneficiaryAccountNumber, dynamicFields = [], beneficiaryStatus, panCardNumber, attendantContactNumber,
    nameMatch, idVerified,
    internalRemark, genderSelect, familyPhysicianName, physicianMobileNumber, attendingRelativeMobile, mediclaimOthers, otherMediclaim,
    investigationDetails, hypertensionMonths, diabetesMonths, estimatedDays, ailmentDuration, anesthesiaType,
    certificateNumber, emergencyContactPerson, stateMedicalCouncil, isEasyDischarge, branch, courierName, consignmentNumber, dispatchDate,
    documentType, noOfFiles, aadharNo, panNumber, typeOfClaim, claimedAmount, documentSubmissionType,
    hospitalizationReason, systemOfMedicine, subGroup, conditionOnDischarge, dateOfExpiry,
    sinceWhenPeriod, sinceWhenDuration, dateOfSurgery, cataractOperatedFor, surgeryType, handedOverTo, podNo, dateOfDelivery,
    dateOfDispatch, courierAgencyName, dateOfInjury, isNHCXClaimFlow,
    isNewBornCase, memberSearchId, rpaStatus, memberNameMatchPercentage, insurerName, payerName,
    reasonForCancellation, uhid, draftId, hospitalId, visitCode, visitType, isDirectPayer,
    patientHISReferenceNumber, isArtemis, searchType, isOrionIntegrationEnabled, treatmentType, productName, selectedPackage,
    payerProductCode,
    claimDetails, isDischargeContest, policySource, dayCareType, reasonForEnhancement, reasonForReconsideration,
  } = props;

  const { icd10, icd10pcs, otherAilment } = treatmentDetail || {};
  const jsonObj: any = {};
  dynamicFields.forEach((ele: any): any => {
    if (treatmentDetail[ele] !== undefined) {
      jsonObj[ele] = treatmentDetail[ele];
      delete treatmentDetail[ele];
    }
  });
  const {
    'Remarks for LOS >90 days': LOSgt90,
    'Remarks for delayed intimation': delayedAdmissionRemark,
    'Remarks for document upload': fileUploadRemarkValue,
    'Discharge Contest': dischargeContestRemarkValue,
  } = remarks || {};

  let fileUploadRemark: string | undefined = '';
  const updatedRemarks = { ...remarks };
  if (!checkEmptyObj(updatedRemarks)) {
    if (claimDetails?.isDischargeContestCTA) {
      // Appending Discharge Contest to remark only for Discharge Contest
      fileUploadRemark = `Discharge Contest: ${dischargeContestRemarkValue}`;
    } else {
      fileUploadRemark = `Remarks for document upload: ${fileUploadRemarkValue}`;
    }
  } else {
    fileUploadRemark = undefined;
  }
  let payerExtension: any[] = [];

  let overallRemark;
  if (!checkEmptyObj(updatedRemarks)) {
    overallRemark = JSON.stringify(updatedRemarks);
  }

  if (additionalAdmissionInfo) {
    const finalStartEndAdmissionTime = {
      admissionStartTime: additionalAdmissionInfo?.admissionStartTime || '',
      admissionEndTime: moment.default().utcOffset('+05:30').format(),
      draftStartTime: additionalAdmissionInfo?.draftStartTime || '',
      draftEndTime: additionalAdmissionInfo?.draftEndTime || '',
      action,
    };
    validateAndUpdateExtension(finalStartEndAdmissionTime, 'newAdmissionDuration', payerExtension);
  }
  validateAndUpdateExtension(ailmentAsPerUser, 'ailmentAsPerUser', payerExtension);
  validateAndUpdateExtension(patientID, 'patientID', payerExtension);
  validateAndUpdateExtension(hospitalNumber, 'hospitalNumber', payerExtension);
  validateAndUpdateExtension(pehchanNo, 'pehchanNo', payerExtension);
  validateAndUpdateExtension(policyType, 'policyType', payerExtension);
  validateAndUpdateExtension(insuranceCardNumber, 'insuranceCardNumber', payerExtension);
  validateAndUpdateExtension(retailOrCorporate, 'retailOrCorporate', payerExtension);
  validateAndUpdateExtension(kycpan, 'kycpan', payerExtension);
  validateAndUpdateExtension(kycAdhaar, 'kycAdhaar', payerExtension);
  validateAndUpdateExtension(drivingLicense, 'drivingLicense', payerExtension);
  validateAndUpdateExtension(voterId, 'voterId', payerExtension);
  validateAndUpdateExtension(isMultipleSurgeries, 'isMultipleSurgeries', payerExtension);
  validateAndUpdateExtension(doctorQualification, 'doctorQualification', payerExtension);
  validateAndUpdateExtension(newPackageName, 'newPackageName', payerExtension);
  validateAndUpdateExtension(doctorMobileNo, 'doctorMobileNo', payerExtension);
  validateAndUpdateExtension(policyStartDate, 'policyStartDate', payerExtension);
  validateAndUpdateExtension(doctorSpecialization, 'doctorSpecialization', payerExtension);
  validateAndUpdateExtension(policyEndDate, 'policyEndDate', payerExtension);
  validateAndUpdateExtension(courierTrackId, 'courierTrackId', payerExtension);
  validateAndUpdateExtension(courierProvider, 'courierProvider', payerExtension);
  validateAndUpdateExtension(switchClick, 'Has the patient utilized this PA?', payerExtension);
  validateAndUpdateExtension(dateOfBirth, 'dateOfBirth', payerExtension);
  validateAndUpdateExtension(beneficiaryAccountNumber, 'beneficiaryAccountNumber', payerExtension);
  validateAndUpdateExtension(beneficiaryStatus, 'status', payerExtension);
  validateAndUpdateExtension(attendantContactNumber, 'attendantContactNumber', payerExtension);
  validateAndUpdateExtension(internalRemark, 'internalRemark', payerExtension);
  validateAndUpdateExtension(stateMedicalCouncil, 'stateMedicalCouncil', payerExtension);
  validateAndUpdateExtension(nameMatch, 'nameMatch', payerExtension);
  validateAndUpdateExtension(idVerified, 'idVerified', payerExtension);
  validateAndUpdateExtension(genderSelect, 'genderSelect', payerExtension);
  validateAndUpdateExtension(familyPhysicianName, 'familyPhysicianName', payerExtension);
  validateAndUpdateExtension(physicianMobileNumber, 'physicianMobileNumber', payerExtension);
  validateAndUpdateExtension(attendingRelativeMobile, 'attendingRelativeMobile', payerExtension);
  validateAndUpdateExtension(mediclaimOthers, 'mediclaimOthers', payerExtension);
  validateAndUpdateExtension(otherMediclaim, 'otherMediclaim', payerExtension);
  validateAndUpdateExtension(investigationDetails, 'investigationDetails', payerExtension);
  validateAndUpdateExtension(hypertensionMonths, 'hypertensionMonths', payerExtension);
  validateAndUpdateExtension(diabetesMonths, 'diabetesMonths', payerExtension);
  validateAndUpdateExtension(estimatedDays, 'estimatedDays', payerExtension);
  validateAndUpdateExtension(ailmentDuration, 'ailmentDuration', payerExtension);
  validateAndUpdateExtension(anesthesiaType, 'anesthesiaType', payerExtension);
  validateAndUpdateExtension(internalRemark, 'internalRemark', payerExtension);
  validateAndUpdateExtension(stateMedicalCouncil, 'stateMedicalCouncil', payerExtension);
  validateAndUpdateExtension(hospitalizationReason, 'hospitalizationReason', payerExtension);
  validateAndUpdateExtension(systemOfMedicine, 'systemOfMedicine', payerExtension);
  validateAndUpdateExtension(subGroup, 'subGroup', payerExtension);
  validateAndUpdateExtension(conditionOnDischarge, 'conditionOnDischarge', payerExtension);
  validateAndUpdateExtension(dateOfExpiry, 'dateOfExpiry', payerExtension);
  validateAndUpdateExtension(sinceWhenDuration, 'sinceWhenDuration', payerExtension);
  validateAndUpdateExtension(sinceWhenPeriod, 'sinceWhenPeriod', payerExtension);
  validateAndUpdateExtension(dateOfSurgery, 'dateOfSurgery', payerExtension);
  validateAndUpdateExtension(cataractOperatedFor, 'cataractOperatedFor', payerExtension);
  validateAndUpdateExtension(surgeryType, 'surgeryType', payerExtension);
  validateAndUpdateExtension(dateOfInjury, 'dateOfInjury', payerExtension);
  validateAndUpdateExtension(isNHCXClaimFlow, 'isNHCXClaimFlow', payerExtension);
  validateAndUpdateExtension(memberSearchId, 'memberSearchRequestId', payerExtension);
  validateAndUpdateExtension(insurerName, 'insurerName', payerExtension);
  validateAndUpdateExtension(payerName, 'payerName', payerExtension);
  validateAndUpdateExtension(uhid, 'uhid', payerExtension);
  validateAndUpdateExtension(visitCode, 'visitCode', payerExtension);
  validateAndUpdateExtension(visitType, 'visitType', payerExtension);
  validateAndUpdateExtension(draftId, 'draftId', payerExtension);
  validateAndUpdateExtension(hospitalId, 'hospitalId', payerExtension);
  validateAndUpdateExtension(isDirectPayer, 'isDirectPayer', payerExtension);
  validateAndUpdateExtension(patientHISReferenceNumber, 'patientHISReferenceNumber', payerExtension);
  validateAndUpdateExtension(searchType, 'searchType', payerExtension);
  validateAndUpdateExtension(selectedPackage, 'selectedPackage', payerExtension);
  validateAndUpdateExtension(isDischargeContest, 'isDischargeContest', payerExtension);
  validateAndUpdateExtension(dayCareType, 'dayCareType', payerExtension);
  validateAndUpdateExtension(reasonForEnhancement, 'reasonForEnhancement', payerExtension);
  validateAndUpdateExtension(reasonForReconsideration, 'reasonForReconsideration', payerExtension);

  validateAndUpdateExtension(isArtemis, 'isArtemis', payerExtension);
  validateAndUpdateExtension(treatmentType, 'treatmentType', payerExtension);
  validateAndUpdateExtension(payerProductCode, 'payerProductCode', payerExtension);

  if (isOrionIntegrationEnabled) {
    validateAndUpdateExtension(isOrionIntegrationEnabled, 'isOrionIntegrationEnabled', payerExtension);
  }

  if (policySource) {
    validateAndUpdateExtension(policySource, 'policySource', payerExtension);
  }
  if (panCardNumber?.length) {
    validateAndUpdateExtension(panCardNumber, 'panCardNumber', payerExtension);
  }
  if (isEasyDischarge) {
    validateAndUpdateExtension(isEasyDischarge, 'isEasyDischarge', payerExtension);

  }
  if (roomType?.length) {
    validateAndUpdateExtension(roomType[0], 'roomType', payerExtension);
  }
  if (certificateNumber?.length) {
    validateAndUpdateExtension(certificateNumber, 'certificateNumber', payerExtension);
  }
  if (emergencyContactPerson?.length) {
    validateAndUpdateExtension(emergencyContactPerson, 'emergencyContactPerson', payerExtension);
  }
  if (stateMedicalCouncil?.length) {
    validateAndUpdateExtension(stateMedicalCouncil, 'stateMedicalCouncil', payerExtension);
  }

  if (hospitalRoomType?.length) {
    validateAndUpdateExtension(hospitalRoomType[0], 'hospitalRoomType', payerExtension);
  }

  if (rpaStatus?.length) {
    validateAndUpdateExtension(rpaStatus, 'rpaStatus', payerExtension);
  }

  if (isNewBornCase) {
    validateAndUpdateExtension(isNewBornCase, 'isNewBornCase', payerExtension);
  }

  if (reasonForCancellation?.length) {
    validateAndUpdateExtension(reasonForCancellation, 'reasonForCancellation', payerExtension);
  }

  if (memberNameMatchPercentage >= 0) {
    validateAndUpdateExtension(memberNameMatchPercentage, 'member_name_match_percentage', payerExtension);
  }

  if (!isEmpty(productName)) {
    validateAndUpdateExtension(productName, 'productName', payerExtension);
  }

  if (ailmetPastHistory?.length) {
    const pastHistory = ailmetPastHistory.map((ailment: any): any => {
      const year = treatmentDetail[`${ailment.name} year`];
      const month = treatmentDetail[`${ailment.name} month`];
      return {
        ...ailment,
        sinceYear: ((year !== undefined && year !== null && year !== '') || (month !== undefined && month !== null && month !== ''))
        ? ((year === 0 || year === undefined || year === null || year === '') && month > 0)
          ? `0.${month}` // Case: year is 0, but month is present
          : (year > 0 && (month === undefined || month === null || month === 0 || month === ''))
            ? `${year}.0` // Case: year is present, but month is 0
            : `${year}.${month}` // Normal case when both year and month are present
        : undefined, // Only set sinceYear if both year and month are valid
      };
    });
    validateAndUpdateExtension(pastHistory, 'pastHistory', payerExtension);
  }
  validateAndUpdateExtension(icd10, 'icd10', payerExtension);
  validateAndUpdateExtension(icd10pcs, 'icd10pcs', payerExtension);
  validateAndUpdateExtension(LOSgt90, 'LOSgt90', payerExtension);
  validateAndUpdateExtension(otherAilment, 'pastHistorysAilmentDetail', payerExtension);
  validateAndUpdateExtension(isRulesConfigured, 'IsRuleConfigured', payerExtension);
  validateAndUpdateExtension(isDeathCase, 'isDeathCase', payerExtension);
  validateAndUpdateExtension(isDischargeCase, 'isDischarge', payerExtension);
  validateAndUpdateExtension(isCovidCase, 'isCovidCase', payerExtension);
  validateAndUpdateExtension(sinceYearDate, 'sinceYearDate', payerExtension);
  validateAndUpdateExtension(memberSearchFailed, 'memberSearchFailed', payerExtension);
  validateAndUpdateExtension(delayedAdmissionRemark, 'delayJustification', payerExtension);
  validateAndUpdateExtension(fileUploadRemark, 'fileUploadRemark', payerExtension);
  validateAndUpdateExtension(overallRemark, 'overallRemarks', payerExtension);
  validateAndUpdateExtension(ProcdureDescAutomation, 'ProcdureDescAutomation', payerExtension);
  validateAndUpdateExtension(isDocChecklistVerified, 'isDocChecklistVerified', payerExtension);
  validateAndUpdateExtension(additionalEmails, 'additionalEmails', payerExtension);

  validateAndUpdateExtension(routeOfAdministration, 'routeOfAdministration', payerExtension);
  validateAndUpdateExtension(presentComplaints, 'presentComplaints', payerExtension);
  validateAndUpdateExtension(pastHistoryOfPresentAilment, 'pastHistoryOfPresentAilment', payerExtension);
  validateAndUpdateExtension(jsonObj, 'questions', payerExtension);
  validateAndUpdateExtension(branch, 'branch', payerExtension);
  validateAndUpdateExtension(courierName, 'courierName', payerExtension);
  validateAndUpdateExtension(consignmentNumber, 'consignmentNumber', payerExtension);
  validateAndUpdateExtension(dispatchDate, 'dispatchDate', payerExtension);
  validateAndUpdateExtension(documentType, 'documentType', payerExtension);
  validateAndUpdateExtension(noOfFiles, 'noOfFiles', payerExtension);
  validateAndUpdateExtension(aadharNo, 'aadharNo', payerExtension);
  validateAndUpdateExtension(panNumber, 'panNumber', payerExtension);
  validateAndUpdateExtension(typeOfClaim, 'typeOfClaim', payerExtension);
  validateAndUpdateExtension(claimedAmount, 'claimedAmount', payerExtension);
  validateAndUpdateExtension(documentSubmissionType, 'documentSubmissionType', payerExtension);
  validateAndUpdateExtension(handedOverTo, 'handedOverTo', payerExtension);
  validateAndUpdateExtension(podNo, 'podNo', payerExtension);
  validateAndUpdateExtension(dateOfDelivery, 'dateOfDelivery', payerExtension);
  validateAndUpdateExtension(dateOfDispatch, 'dateOfDispatch', payerExtension);
  validateAndUpdateExtension(courierAgencyName, 'courierAgencyName', payerExtension);

  payerExtension = payerExtension.concat(maternityExtension(treatmentDetail));
  payerExtension = payerExtension.concat(cataractExtension(treatmentDetail));
  payerExtension = payerExtension.concat(accidentExtension(treatmentDetail));
  payerExtension = payerExtension.concat(covidExtension(treatmentDetail));
  payerExtension = payerExtension.concat(otherMemberDetailExtension(otherMemberDetail));
  payerExtension = payerExtension.concat(otherTreatmentDetailExtension(treatmentDetail));
  payerExtension = payerExtension.concat(otherFormTreatmentDetailExtension(otherFormDetail));
  return payerExtension;
};

export const setMemberId = (memberDetail: any[], memberId: number): any[] => {
  return memberDetail;
};

export const migrateToUploadedDoc = (claimFlowData: any[]): any => {
  if (!claimFlowData) {
    return [];
  }
  return claimFlowData.reduce(
    (allDocs: any, { documents, createdDate, status: claimStatus }: any): any => {
      documents = (
        documents
          ?.filter(({ isPayerAttachment }: any): boolean => !isPayerAttachment)
          ?.map((document: any): any => (
            { ...document, createdDate: getDateWithTime(createdDate), claimStatus }),
          )) || [];
      return [...allDocs, ...documents];
    },
    [],
  ).map((document: any, index: number): any => ({
    uid: document.fileIdentifier + index,
    name: document.fileName,
    status: 'done',
    existingRecord: true,
    percent: 100,
    ...document,
    response: {
      errorMsg: '',
      isSuccess: true,
      uploadedDetails: [{ ...document, fileGuid: document.fileIdentifier }],
    },
    fileType: document?.fileType,
  }));
};

export const getPayerDocs = (claimFlowData: any[]): any => {
  if (!claimFlowData) {
    return [];
  }
  return claimFlowData.reduce(
    (allDocs: any, { documents, createdDate, status: claimStatus }: any): any => {
      documents = (
        documents
          ?.filter(({ isPayerAttachment }: any): boolean => isPayerAttachment)
          ?.map((document: any): any => (
            { ...document, createdDate: getDateWithTime(createdDate), claimStatus }),
          )) || [];
      return [...allDocs, ...documents];
    },
    [],
  ).map((document: any, index: number): any => ({
    uid: document.fileIdentifier + index,
    name: document.fileName,
    status: 'done',
    existingRecord: true,
    percent: 100,
    ...document,
    response: {
      errorMsg: '',
      isSuccess: true,
      uploadedDetails: [{ ...document, fileGuid: document.fileIdentifier }],
    },
    fileType: document?.fileType,
  }));
};

export const alreadyUploadedDocs = (claimFlowData: any[]): any => {
  if (!claimFlowData) {
    return [];
  }
  return claimFlowData.reduce(
    (allDocs: any, { documents, createdDate, status: claimStatus }: any): any => {
      documents = (
        documents
          ?.map((document: any): any => (
            { ...document, createdDate: getDateWithTime(createdDate), claimStatus }),
          )) || [];
      return [...allDocs, ...documents];
    },
    [],
  ).map((document: any, index: number): any => ({
    uid: document.fileIdentifier + index,
    name: document.fileName,
    status: 'done',
    existingRecord: true,
    percent: 100,
    ...document,
    response: {
      errorMsg: '',
      isSuccess: true,
      uploadedDetails: [{ ...document, fileGuid: document.fileIdentifier }],
    },
    fileType: document?.fileType,
    isPayerAttachment: document?.isPayerAttachment,
  }));
};

export const getValue = (obj: any, path: string = '', isReturnDefaultStr: boolean = false): any => {
  return getDefaultStr(get(obj, path), isReturnDefaultStr);
};

export const getDefaultStr = (value: any, isReturnDefaultStr: boolean = false, convertArrToStr: boolean = false): any => {
  if (value?._isAMomentObject) { // bugfix-IPP-4357-committed
    value = value?.toISOString()?.split('T')[0];
  }
  if (value && typeof value === 'number') {
    value = value.toString();
  } else if (Array.isArray(value) && convertArrToStr) {
    value = value.join(' - ');
  }
  return (value === null || value === undefined || value === '')
    ? (isReturnDefaultStr ? '-' : undefined)
    : value;
};

export const getNextAllowStatus = (
  allowStatus: any,
  dod?: any,
  action?: string,
  isCorporatePayer?: boolean,
  isCashlessSubmit: boolean = false,
  isEasyDischargeCase?: boolean,
  pathname: string = '',
  isIntegratedPayer?: boolean,
): any => {
  let nextAllowStatus = [];
  const statusBasedOnDod = intersectionWith(
    ACTION_ADMISSION_SUBMIT,
    allowStatus,
    (statusName: string, { actionName }: any): boolean => statusName === actionName);

  const statusAllowedForCorporate = intersectionWith(
    ACTION_CORPORATE_EDIT,
    allowStatus,
    (statusName: string, { actionName }: any): boolean => statusName === actionName);

  const statusAllowedForReimbursement = intersectionWith(
    ACTION_REIMBURSEMENT,
    allowStatus,
    (statusName: string, { actionName }: any): boolean => statusName === actionName);

  if (statusAllowedForReimbursement?.length) {
    nextAllowStatus = allowStatus
      .filter(({ actionName }: any): boolean => ACTION_REIMBURSEMENT.includes(actionName));
  } else if (isCorporatePayer && statusAllowedForCorporate?.length) {
    if (action === '' && getIsPageNameEdit(pathname)) {
      nextAllowStatus = allowStatus
        .filter(({ actionName }: any): boolean => [actions.ENHANCEMENT].includes(actionName));
    } else if (action === actions.EDIT) {
      nextAllowStatus = allowStatus
        .filter(({ actionName }: any): boolean => [actions.EDIT].includes(actionName));
    }
  } else {
    if (!statusBasedOnDod.length) {
      return [];
    }
    if (dod) {
      if (isCashlessSubmit || action === actions.CASHLESSSUMBIT) {
        nextAllowStatus = allowStatus.filter(({ actionName }: any): boolean => actionName === actions.CASHLESSSUMBIT);
      } else if (isEasyDischargeCase && statusBasedOnDod.includes(actions.EASYDISCHARGEINITIATED)) {
        nextAllowStatus = allowStatus.filter(({ actionName }: any): boolean => actionName === actions.EASYDISCHARGEINITIATED);
      } else if (statusBasedOnDod.includes(actions.RECONSIDER) && getIsPageNameReconsider(pathname)) {
        nextAllowStatus = allowStatus.filter(({ actionName }: any): boolean => actionName === actions.RECONSIDER);
      } else {
        // Handle `DISCHARGE` and `ENHANCEMENT` based on whether payer is integrated
        if (isIntegratedPayer) {
          if (getIsPageNameEditDischarge(pathname) && statusBasedOnDod.includes(actions.DISCHARGE)) {
            nextAllowStatus = allowStatus.filter(({ actionName }: any): boolean => actionName === actions.DISCHARGE);
          } else if (statusBasedOnDod.includes(actions.ENHANCEMENT) && getIsPageNameEdit(pathname)) {
            nextAllowStatus = allowStatus.filter(({ actionName }: any): boolean => actionName === actions.ENHANCEMENT);
          } else if (
            getIsPageNameEditDischarge(pathname) &&
            statusBasedOnDod.includes(actions.DISCHARGECONTEST) &&
            allowStatus.some(({ actionName }: any): boolean => actionName === actions.DISCHARGECONTEST)
          ) {
            nextAllowStatus = [{ actionName: actions.DISCHARGE }];
          } else {
            nextAllowStatus = allowStatus.filter(({ actionName }: any): boolean => OTHERTHEN_DISCHARGE.includes(actionName));
          }
        } else {
          // For non-integrated payers, check dod for `DISCHARGE` and `ENHANCEMENT`
          if ( statusBasedOnDod.includes(actions.DISCHARGE) &&
            moment.default(dod).isSameOrBefore(moment.default(new Date()), 'day')) {
            nextAllowStatus = allowStatus.filter(({ actionName }: any): boolean => actionName === actions.DISCHARGE);
          } else if ( statusBasedOnDod.includes(actions.ENHANCEMENT) &&
            moment.default(dod).isAfter(moment.default(new Date()), 'day')) {
            nextAllowStatus = allowStatus.filter(({ actionName }: any): boolean => actionName === actions.ENHANCEMENT);
          } else if (
            statusBasedOnDod.includes(actions.DISCHARGECONTEST) &&
            allowStatus.some(({ actionName }: any): boolean => actionName === actions.DISCHARGECONTEST)
          ) {
            nextAllowStatus = [{ actionName: actions.DISCHARGE }];
          } else {
            nextAllowStatus = allowStatus.filter(({ actionName }: any): boolean => OTHERTHEN_DISCHARGE.includes(actionName));
          }
        }
      }
    } else if (isCashlessSubmit) {
      nextAllowStatus = allowStatus
        .filter(({ actionName }: any): boolean => actionName === actions.CASHLESSSUMBIT);
    } else if (action === actions.RECONSIDER && getIsPageNameReconsider(pathname)) {
      nextAllowStatus = allowStatus
        .filter(({ actionName }: any): boolean => actionName === actions.RECONSIDER);
    } else if (action === actions.EASYDISCHARGEINITIATED) {
      nextAllowStatus = allowStatus
        .filter(({ actionName }: any): boolean => actionName === actions.EASYDISCHARGEINITIATED);
    } else if (action === actions.EASYDISCHARGEQUERYREPLIED) {
      nextAllowStatus = allowStatus
        .filter(({ actionName }: any): boolean => actionName === actions.EASYDISCHARGEQUERYREPLIED);
    } else if (action === actions.CANCEL) {
      nextAllowStatus = allowStatus.filter(({ actionName }: any): boolean => actionName === actions.CANCEL);
    } else {
      nextAllowStatus = allowStatus
        .filter(({ actionName }: any): boolean => ACTION_ADMISSION_SUBMIT.includes(actionName));
    }
  }
  return nextAllowStatus.map(({ actionName, documentName }: any): any => ({ actionName, documentName }));
};

export const isAvailable = (items: any[], actionName: string): boolean =>
  items.some(({ actionName: aName }: any): boolean => aName === actionName);

export const isBlocked = (blockedActions: {}, actionName: string): boolean =>
  blockedActions?.hasOwnProperty(actionName) ? true : false;

export const isFormElemEditable = (editFor: any[] = [], claimDetails: any = {}): any =>
  editFor.length && Object.keys(claimDetails).length && intersection(editFor, claimDetails.nextAllowStatus).length;

export const findKeyValuePair = (array: any[] = [], keyToCheck: string, valueToMatch: any, isIgnoreCase?: boolean): any => {
  return array?.find((element: any): boolean => {
    if (isIgnoreCase && (typeof valueToMatch) === 'string') {
      return (`${element[keyToCheck]}`)?.toLowerCase() === (valueToMatch)?.toLowerCase();
    } else {
      return `${element[keyToCheck]}` === valueToMatch;
    }
  });
};

export const findKeyValuePairInsurerName = (array: any[], keyToCheck: string, valueToMatch: any, isIgnoreCase?: boolean): any => {
  const replaceSpclChar = (value: any): any => {
    return isIgnoreCase ? value?.replace(SPCL_CHARACTER, '')?.toLowerCase() : value?.replace(SPCL_CHARACTER, '');
  };

  return array?.find((element: any): any => {
    const elementValue = replaceSpclChar(element?.[keyToCheck]);
    const searchValue = isIgnoreCase ? replaceSpclChar(valueToMatch) : valueToMatch;
    return elementValue?.includes(searchValue);
  });
};

export const getNoOfDays = (dateOfAdmission?: moment.Moment, dateOfDischarge?: moment.Moment): number => {
  let noOfDays = 1;
  if (dateOfAdmission && dateOfDischarge) {
    noOfDays = dateOfDischarge.diff(dateOfAdmission, 'days') + 1;
    if (noOfDays < 1) {
      noOfDays = 1;
    }
  }
  return noOfDays;
};

export const getNoOfHours = (startDate?: moment.Moment, endDate?: moment.Moment): number => {
  let noOfHours = 0;
  if (startDate && endDate) {
    noOfHours = moment.duration(endDate.diff(startDate)).asHours();
  }
  return noOfHours;
};

export function getPackageCost(noOfDays: number, dialysis: any, is_Per_Day_Eligible_Package: boolean, totalPackageCost: number): number {
  if (dialysis) {
    return totalPackageCost / parseInt(dialysis, 10);
  }
  if (is_Per_Day_Eligible_Package) {
    return totalPackageCost / noOfDays;
  }
  return totalPackageCost;
}

export const claimDetailMigrateToClaimForm = (
  claimDetail: any,
  pathname: string,
  configuredPayers: any,
  { district: allDistricts, relation: allRelations = [] }: any): any => {
  const appDetailService = ApplicationDetail.instance;
  const {
    insurerName, roomType = [], hospitalRoomType = [], procedureDescAutomation, doa, dod, diagnosis = [], procedureType,
    procedureDesc = [], payerId,
    materinity, pastHistory, pastHistorysAilmentDetail,
    claimBillDetails = [], isAccident, productCode, patientAge, patientGender,
    govtScheme = {}, cataract: cataractObj = {}, dialysis: dialysisObj, isDeathCase, isDischarge, isCovidCase, isMultipleSurgeries,
    claimFlowData = [], dateOfBirth, dateOfDiagnosis, sinceYearDate,
    courierStatus, patientMobileNo, isMLC, dateOfSurgery, dateOfExpiry, lmp, permanentDisability, dateOfCommencement, isNewBornCase,
    isNHCXClaimFlow,
  } = claimDetail;
  const { dialysis } = dialysisObj || {};
  let { allowStatus = [] } = claimDetail;
  if (allowStatus === null) {
    allowStatus = [];
  }
  if (courierStatus?.length > 0) {
    courierStatus?.sort((a: any, b: any): any => {
      return a.StatusDate > b.statusDate ? -1 : a.statusDate < b.statusDate ? 1 : 0;
    });
  }
  let isCancelable; let isConfirmable; let isCashlessSubmission; let isQuery; let isEnhance; let isFreeEditable; let isRIquery;
  let isReconsider; let isEasyDischarge; let isEasyDischargeQuery; let isPaymentAcknowledged; let isDischargeCTA; let isDischargeContestCTA;
  const oldDocsAllowed = !!((claimFlowData || []).find(({ statusId }: any): boolean => statusId === 8));
  const uniqueId = `${payerId}${productCode || ''}`;
  const selectedPayer = configuredPayers.find(({ uniqueIdentifier }: any): boolean => uniqueIdentifier === uniqueId);
  if (allowStatus?.length) {
    const {
      CANCEL, CONFIRMATION, CASHLESSSUMBIT, SUBMITINFO, ENHANCEMENT, EDIT, ENHANCEMENTQUERYREPLIED, DISCHARGEQUERYREPLIED,
      REIMBURSEMENTQUERYREPLIED, CLAIMQUERYREPLIED, RECONSIDER, EASYDISCHARGEINITIATED, EASYDISCHARGEQUERYREPLIED,
    } = actions;
    isCancelable = allowStatus.some(({ actionName }: any): boolean => actionName === CANCEL);
    isConfirmable = allowStatus.some(({ actionName }: any): boolean => actionName === CONFIRMATION);
    isEnhance = isAvailable(allowStatus, ENHANCEMENT) && !isBlocked(selectedPayer?.blockedActions, ENHANCEMENT);
    isCashlessSubmission = isDateLessThenToday(dod, claimDetail?.payerName) ? isAvailable(allowStatus, CASHLESSSUMBIT)
      && !isBlocked(selectedPayer?.blockedActions, CASHLESSSUMBIT) :
      false;
    isQuery = (isAvailable(allowStatus, SUBMITINFO) || isAvailable(allowStatus, ENHANCEMENTQUERYREPLIED)
      || isAvailable(allowStatus, DISCHARGEQUERYREPLIED) || isAvailable(allowStatus, CLAIMQUERYREPLIED))
      && !isBlocked(selectedPayer?.blockedActions, SUBMITINFO);
    isReconsider = allowStatus.some(({ actionName }: any): boolean => actionName === RECONSIDER);
    isFreeEditable = isAvailable(allowStatus, EDIT);
    isRIquery = isAvailable(allowStatus, REIMBURSEMENTQUERYREPLIED);
    isEasyDischargeQuery = isAvailable(allowStatus, EASYDISCHARGEQUERYREPLIED);
    isEasyDischarge = isAvailable(allowStatus, EASYDISCHARGEINITIATED);
    isPaymentAcknowledged = isAvailable(allowStatus, actions.ACKNOWLEDGEPAYMENT) && isNHCXClaimFlow;
    isDischargeCTA = isAvailable(allowStatus, actions.DISCHARGE);
    isDischargeContestCTA = isAvailable(allowStatus, actions.DISCHARGECONTEST);
  }
  const { dateOfInjury, firNumber, isItARta, injuryOrDeseaseCaused, isReportedToPolice,
    testConductedToEstablishedThis } = isAccident || {};
  const getFormLookUpValue = getValueFormLookUp(pathname);

  const billDetail = claimBillDetails?.reduce(
    (allBills: any, { billPackageName, billAmount, billLevel3CategoryName }: any): any => {
      const billDropDownValue = billLevel3CategoryName;
      const splitString = billDropDownValue?.split(',')[1];
      allBills[billPackageName] = allBills[billPackageName] ? allBills[billPackageName] + billAmount : billAmount;
      const selectedValue = billDropDownValue?.split(',')[0];
      allBills[splitString] = selectedValue;

      return allBills;
    }, {},
  );

  const dateOfAdmission = moment.default(doa);
  const dateOfDischarge = moment.default(dod);
  const noOfDays = getNoOfDays(dateOfAdmission, dateOfDischarge);
  const uniqClaimBillDetails = uniqBy(claimBillDetails, 'billPackageId');
  const selectedPackage = uniqClaimBillDetails
    .filter(({ billPackageId }: any): boolean => billPackageId > 0)
    .map(({ billPackageName: name, billPackageId: value, billAmount: packageCost, is_Per_Day_Eligible_Package }: any): any =>
    ({
      name, value, packageCost: getPackageCost(noOfDays, dialysis?.dialysis, is_Per_Day_Eligible_Package, packageCost),
      is_Per_Day_Eligible_Package,
    }));

  const { district, employeename: employeeName, relation } = govtScheme;
  let districtObj = {};
  let relationObj = {};
  if (district) {
    districtObj = findKeyValuePair(allDistricts, 'payerMasterId', district) || {};
  }
  if (relation) {
    // TODO: Replace 'payerMasterValue' to 'payerMasterId' in future if relation is being fetched from ID
    relationObj = findKeyValuePair(allRelations, 'payerMasterValue', relation, true) || {};
  }
  let cataract = {};
  if (!isEmpty(cataractObj)) {
    const { lenseId: lId, ailmentid: aId } = cataractObj;
    const lenseObj = findKeyValuePair(CATARACT_LENS_TYPE, 'id', lId);
    const ailmentObj = findKeyValuePair(CATARACT_TYPE, 'id', aId);
    cataract = {
      lenseId: lenseObj ? getFormLookUpValue([lenseObj], false, 'name') : null,
      ailmentid: ailmentObj ? getFormLookUpValue([ailmentObj], false, 'name') : null,
    };
  }
  const filteredDiagnosis = diagnosis ?
    diagnosis?.filter(({ payerMasterValue, masterLookId }: any): boolean => payerMasterValue || masterLookId !== -1)
    : [];
  const filteredProcedureDesc = procedureDesc ?
    procedureDesc?.filter(({ payerMasterValue, masterLookId }: any): boolean => payerMasterValue || masterLookId !== -1)
    : [];
  const finalProposedLineOfTreat = getFormLookUpValue(procedureType, false);
  const filteredAutoProcedure = getFormLookUpValue((procedureDescAutomation && procedureDescAutomation[0]) ?
    procedureDescAutomation : [], false, 'maMappedProcedure');
  let finalAutomatedProcedure = getIsPageNameDetail(pathname) ? PROCEDURE_OTHER_TYPES[0].name : PROCEDURE_OTHER_TYPES[0].value;
  if (filteredAutoProcedure) {
    finalAutomatedProcedure = Array.isArray(filteredAutoProcedure) ? filteredAutoProcedure[0] : filteredAutoProcedure;
  }

  const finalPayerRoomType = (roomType?.length) ?
    (Array.isArray(getFormLookUpValue(roomType)) ? getFormLookUpValue(roomType)[0] : getFormLookUpValue(roomType)) :
    undefined;

  const finalHospRoomType = Array.isArray(getFormLookUpValue(hospitalRoomType, false, 'providerRoomType', 'providerRoomType')) ?
    getFormLookUpValue(hospitalRoomType, false, 'providerRoomType', 'providerRoomType')[0] :
    getFormLookUpValue(hospitalRoomType, false, 'providerRoomType', 'providerRoomType');

  claimDetail = {
    ...claimDetail,
    ...billDetail,
    patientMobileNo: isNaN(patientMobileNo) ? null : patientMobileNo,
    materinity,
    govtScheme: {
      ...govtScheme,
      employeeName,
      district: getFormLookUpValue([districtObj], true),
      relation: getFormLookUpValue([relationObj], true) || govtScheme?.relation,
    },
    oldDocsAllowed,
    employeeName,
    memberAge: parseInt(patientAge, 10),
    memberGenderSex: patientGender,
    insurerName: getFormLookUpValue(insurerName),
    insurerNameText: getFormLookUpValue(insurerName),
    dateOfAdmission: getFormDateValue(pathname, doa),
    dateOfDischarge: getFormDateValue(pathname, dod),
    startDate: getFormDateValue(pathname, dod),
    endDate: getFormDateValue(pathname, dod),
    dateOfBirth: getFormDateValue(pathname, dateOfBirth),
    dateOfDiagnosis: getFormDateValue(pathname, dateOfDiagnosis),

    proposedLineOfTreatment: appDetailService.getIsNewAutomationEnabled() && Array.isArray(finalProposedLineOfTreat) ?
      finalProposedLineOfTreat[0] : finalProposedLineOfTreat,

    hospitalRoomType: finalHospRoomType || (getIsPageNameDetail(pathname) ? 'Others' : OTHER_ID),
    payerRoomType: finalPayerRoomType,
    roomTypeText: finalPayerRoomType,

    originalDiagnosis: filteredDiagnosis,
    diagnosis: getFormLookUpValue(filteredDiagnosis, false),
    automatedProcedure: finalAutomatedProcedure,
    procedure: getFormLookUpValue(filteredProcedureDesc, false),

    payerActualId: payerId,
    payerId: getValue(selectedPayer, 'name', true),
    dateOfInjury: getFormDateValue(pathname, dateOfInjury),
    pastHistory: pastHistory ? pastHistory : undefined,
    ailment: getFormLookUpValue(pastHistory, false),
    otherAilment: pastHistorysAilmentDetail,
    firNumber,
    isCancelable, isConfirmable, isCashlessSubmission, isQuery, isEnhance, isFreeEditable, isRIquery,
    isReconsider,
    isEasyDischarge,
    isEasyDischargeQuery,
    isPaymentAcknowledged,
    isDischargeCTA,
    isDischargeContestCTA,
    isItARta: getBooleanInText(isItARta, pathname),
    injuryOrDeseaseCaused: getBooleanInText(injuryOrDeseaseCaused, pathname),
    isReportedToPolice: getBooleanInText(isReportedToPolice, pathname),
    testConductedToEstablishedThis: getBooleanInText(testConductedToEstablishedThis, pathname),
    selectedPackage: (getIsPageNameEdit(pathname) || getIsPageNameEditDischarge(pathname) ||
      getIsPageNameReconsider(pathname)) ? [] : selectedPackage,
    cataract, allowStatus,
    isDeathCase: isDeathCase ? 'Yes' : undefined,
    isDischargeCase: isDischarge ? 'Yes' : undefined,
    isCovidCase: isCovidCase ? 'Yes' : undefined,
    sinceYearDate: sinceYearDate !== null ? sinceYearDate : undefined,
    isMultipleSurgeries: getBooleanInText(isMultipleSurgeries, pathname),
    isMLC: isMLC ? 'Yes' : undefined,
    permanentDisability: permanentDisability === 'true' ? 'Yes' : undefined,
    lmp: getFormDateValue(pathname, lmp),
    dateOfExpiry: getFormDateValue(pathname, dateOfExpiry),
    dateOfSurgery: getFormDateValue(pathname, dateOfSurgery),
    dateOfCommencement: getFormDateValue(pathname, dateOfCommencement),
    isNewBornCase: isNewBornCase ? 'Yes' : undefined,

  };
  return claimDetail;
};

const parseBoolean = (value: string | undefined | null): boolean | undefined | string | null =>
  value ? ((value === 'true') ? true : (value === 'false' ? false : true)) : value;

const getBooleanInText = (value: string | undefined | null, url: string): boolean | undefined | string | null => {
  const parsedValue = parseBoolean(value);

  if (parsedValue === undefined || parsedValue === null) {
    return;
  }
  if (url.includes(IN_PATIENT_PAGE_NAME.detail) && !(url.includes(IN_PATIENT_PAGE_NAME.edit) ||
    url.includes(IN_PATIENT_PAGE_NAME.discharge) || url.includes(IN_PATIENT_PAGE_NAME.reconsider))) {
    return parsedValue ? 'Yes' : 'No';
  } else {
    return parsedValue;
  }
};

export const getFormDateValue = (url: string, date: moment.Moment): string | moment.Moment | undefined => {
  if (!date) {
    return;
  }
  if (url.includes(IN_PATIENT_PAGE_NAME.detail) && !(url.includes(IN_PATIENT_PAGE_NAME.edit) ||
    url.includes(IN_PATIENT_PAGE_NAME.discharge) || url.includes(IN_PATIENT_PAGE_NAME.reconsider))) {
    return moment.default(date).format(COMMON_DATE_FORMAT);
  } else {
    return moment.default(date);
  }
};

const getValueFormLookUp = (url: string): any =>
  (detailKeyName: any, isOnlyFirstElem: boolean = true, exactKeyName?: string, exactkeyId?: string): string | string[] | any => {
    if (!detailKeyName || isEmpty(detailKeyName)) {
      return;
    }
    const selectedVal: string[] = detailKeyName?.map(
      (detail: any): string => {
        const { masterLookId, payerMasterValue, id, value, procedure } = detail;
        if (
          (masterLookId === -1) ||
          (id === -1) ||
          (url.includes(IN_PATIENT_PAGE_NAME.detail) && !(url.includes(IN_PATIENT_PAGE_NAME.edit) ||
            url.includes(IN_PATIENT_PAGE_NAME.discharge) || url.includes(IN_PATIENT_PAGE_NAME.reconsider)))
        ) {
          return (exactKeyName && detail[exactKeyName]) ? `${detail[exactKeyName]}` : (payerMasterValue || value || procedure);
        }
        return (exactkeyId && detail[exactkeyId]) ?
          `${detail[exactkeyId]}` :
          (masterLookId && masterLookId.toString()) || (id && id.toString());
      });

    if (isOnlyFirstElem) {
      return selectedVal[0];
    } else {
      if (url.includes(IN_PATIENT_PAGE_NAME.detail) && !(url.includes(IN_PATIENT_PAGE_NAME.edit) ||
        url.includes(IN_PATIENT_PAGE_NAME.discharge) || url.includes(IN_PATIENT_PAGE_NAME.reconsider))) {
        return selectedVal.join(', ');
      } else {
        return selectedVal;
      }
    }
  };

export const getInPatientPageName = (url: string): string => {
  let pageName: string = IN_PATIENT_PAGE_NAME.newAdmission;
  if (url.includes(IN_PATIENT_PAGE_NAME.newAdmission)) {
    pageName = IN_PATIENT_PAGE_NAME.newAdmission;
  } else if (url.includes(IN_PATIENT_PAGE_NAME.detail) && !url.includes(IN_PATIENT_PAGE_NAME.edit)
    && !url.includes(IN_PATIENT_PAGE_NAME.discharge) && !url.includes(IN_PATIENT_PAGE_NAME.reconsider)
     && !url.includes(IN_PATIENT_PAGE_NAME.cancel)) {
    pageName = IN_PATIENT_PAGE_NAME.detail;
  } else if (url.includes(IN_PATIENT_PAGE_NAME.edit)) {
    pageName = IN_PATIENT_PAGE_NAME.edit;
  } else if (url.includes(IN_PATIENT_PAGE_NAME.discharge)) {
    pageName = IN_PATIENT_PAGE_NAME.discharge;
  } else if (url.includes(IN_PATIENT_PAGE_NAME.reconsider)) {
    pageName = IN_PATIENT_PAGE_NAME.reconsider;
  } else if (url.includes(IN_PATIENT_PAGE_NAME.cancel)) {
    pageName = IN_PATIENT_PAGE_NAME.cancel;
  } else if (url.includes(IN_PATIENT_PAGE_NAME.grievance)) {
    pageName = IN_PATIENT_PAGE_NAME.grievance;
  } else {
    pageName = '';
  }
  return pageName;
};

export const getGrievancePageName = (url: string): string => {
  let pageName: string = IN_PATIENT_PAGE_NAME.grievance;
  if (url.includes(IN_PATIENT_PAGE_NAME.grievance)) {
    pageName = IN_PATIENT_PAGE_NAME.grievance;
  } else {
    pageName = '';
  }
  return pageName;
};

export const getIsPageNameDetail = (url: string): boolean =>
  getInPatientPageName(url) === IN_PATIENT_PAGE_NAME.detail;

export const getIsInitialSettlement = (url: string): boolean =>
  url.includes(`${base64UrlEncode(actions.CASHLESSSUMBIT)}`);

export const getIsPageNameEdit = (url: string): boolean =>
  getInPatientPageName(url) === IN_PATIENT_PAGE_NAME.edit;

export const getIsPageNameCancel = (url: string): boolean =>
  getInPatientPageName(url) === IN_PATIENT_PAGE_NAME.cancel;

export const getIsPageNameEditDischarge = (url: string): boolean =>
  getInPatientPageName(url) === IN_PATIENT_PAGE_NAME.discharge;

export const getIsPageNameReconsider = (url: string): boolean =>
  getInPatientPageName(url) === IN_PATIENT_PAGE_NAME.reconsider;

export const getIsPageNameNewAdmission = (url: string): boolean =>
  getInPatientPageName(url) === IN_PATIENT_PAGE_NAME.newAdmission;

export const getIsPageNameInpatientList = (url: string): boolean =>
  getInPatientPageName(url) === IN_PATIENT_PAGE_NAME.newAdmission;

export const getIsPageGrievance = (url: string): boolean =>
  getGrievancePageName(url) === IN_PATIENT_PAGE_NAME.grievance;

export const getPreviousUrl = (url: string): string => {
  const splitted = url.split('/');
  splitted.length = splitted[splitted.length - 2] === 'edit' || splitted[splitted.length - 2] === 'detail' ?
    splitted.length - 2 : splitted.length - 1;
  return splitted.join('/');
};

export const getValidUploadedFiles = (aFileList: any[]): any[] =>
  aFileList.filter(({ existingRecord, status }: any): boolean => !existingRecord && (status === 'uploading' || status === 'done'));

export function getUploadingFile(fList: any[]): any {
  let file;
  fList
    .some((fileItem: UploadFile): any => {
      if (fileItem.status === 'uploading') {
        file = fileItem;
      }
    });

  return file;
}

export function getFileUploadStatus<T>(fList: any[], progressArr: T[]): T {
  let progress: T;
  const [progress33, progress66, progress100] = progressArr;
  const statusUploading = fList
    .some(({ status }: UploadFile): boolean => status === 'uploading');

  if (statusUploading) {
    progress = progress33;
  } else {
    const statusVerifying = fList
      .some(({ status, extendedStatus }: any): boolean => status === 'done' && extendedStatus === 'verifying');
    if (statusVerifying) {
      progress = progress66;
    } else {
      progress = progress100;
    }
  }
  return progress;
}

const getQuestionSetByPrecedence = (existingClassification: any[] = [], generatedClassification: any[] = []): any[] => {
  const finalArr: any[] = [];
  if (!existingClassification?.length) {
    return generatedClassification;
  }
  for (const classification of existingClassification) {
    const availableClassification =
      generatedClassification.find(({ questionType }: any): boolean => classification['questionType'] === questionType);
    if (availableClassification) {
      if (classification['answer']) {
        finalArr.push(classification);
      } else {
        finalArr.push(availableClassification);
      }
    }
  }
  const newEntry = generatedClassification?.filter(({ questionType: id1 }: any): boolean =>
    !finalArr?.some(({ questionType: id2 }: any): boolean => id2 === id1));
  return [...finalArr, ...newEntry];
};

export const getNonAvailableClassification = (
  mandatoryClassificationArr: any[],
  fileList: any[],
  existingNonAvailableClassification: any[]): any[] => {
  const validFileList = getValidUploadedFiles(fileList);
  let nonAvailableClass: any[] = [];
  if (validFileList?.length) {
    nonAvailableClass = mandatoryClassificationArr.filter(
      (classification: any): boolean => {
        return validFileList.every(({ fileType }: any): boolean => {
          const { questionType } = classification;
          let isDescripancyAvailable = true;
          if (fileType?.length) {
            isDescripancyAvailable = fileType.indexOf(questionType) < 0;

            if (!isDescripancyAvailable) {
              classification.answer = 'yes';
            } else {
              // checking the file types for document checklist as the question type differes
              isDescripancyAvailable = !(
                (fileType?.includes('kyc') && questionType === 'Patients ID Proof') ||
                (fileType?.includes('claim_form') && questionType === 'Pre-auth/claim form') ||
                (fileType?.includes('bill') && questionType === 'Estimated bill as per agreed tariff (as applicable)') ||
                (fileType?.includes('declaration_form') && questionType === 'Declaration form/GIPSA certificate') ||
                (fileType?.includes('discharge_summary') && questionType === 'Discharge Summary') ||
                (fileType?.includes('bill') && questionType === 'Detailed bill as per agreed tariff (as applicable)')
              );

              if (!isDescripancyAvailable) {
                classification.answer = 'yes';
              }
            }
          }
          return isDescripancyAvailable;
        });
      });
  }
  return getQuestionSetByPrecedence(existingNonAvailableClassification, nonAvailableClass);
};

export const getTotal = (fields: any): number => {
  let total = 0;
  Object.keys(fields).forEach((key: string): any => {
    total += fields[key] ? parseInt(fields[key], 10) : 0;
  });
  return total;
};

export const isBlankArray = (arr: any[]): boolean => {
  for (const item of arr) {
    if (item) {
      return false;
    }
  }
  return true;
};

export const getCurrentSubmissionType = (status: string): any => {
  switch (status) {
    case 'CASHLESSSUMBIT':
      return 'settlement initiation';
    case 'ENHANCEMENT':
      return 'enhancement request';
    case 'SUBMITINFO':
      return 'query response';
    case 'DISCHARGE':
      return 'discharge request';
    case 'CANCEL':
      return 'cancel request';
    default:
      return 'enhancement/discharge/settlement/pre auth query';
  }
};

export const formatSelectedFilter = (
  selectedFilter: Record<string, any>,
): any[] => {
  const filter = selectedFilter || {};
  const keys = Object?.keys(filter);

  return keys
    ?.map((key: any): any => {
      const value = filter?.[key];
      if (!value || value?.length === 0 || isBlankArray(value)) {
        return null;
      }
      let formattedValue = Array?.isArray(value) ? value : [value];
      if (key === DATE_FILTER) {
        formattedValue = formattedValue?.flatMap(
          (val: any): any => (DATE_DROPDOWN_MODELIING as any)?.[val] || val,
        );
      }
      return { key, value: formattedValue };
    })
    ?.filter(Boolean);
};

// Member id validation for ABHI
export const abhiValidation = ({ getFieldValue }: any): any => ({
  validator(): any {
    const memberSearchValue = getFieldValue('memberId');
    if (GHI_VALIDATION_REGEX.test(memberSearchValue.toUpperCase())) {
      return Promise.reject(ABHI_MEMBER_SEARCH_ERR_MSG);
    } else if (HYPHEN_REGEX.test(memberSearchValue)) {
      return Promise.reject(ABHI_MEMBER_SEARCH_VALIDATION_MESSAGE);
    }
    return Promise.resolve();
  },
});

export const validateMDIMemberIdInput = ({ getFieldValue }: any): any => ({
  validator(): any {
    const memberSearchValue = getFieldValue('memberId') || '';
    if (MDI_MEMEBERID_REGEX.test(memberSearchValue.toUpperCase())) {
      return Promise.reject(`${MDI_MEMBERID_VALID_MESSAGE} (${MDI_MEMBERID_PREFIX})`);
    }
    return Promise.resolve();
  },
});

export const doaDodValidation = ({ getFieldValue }: any): any => ({
  validator(): any {
    if (
      !getFieldValue('stayLength') ||
      (Array?.isArray(getFieldValue('stayLength')) && isBefore(getFieldValue('stayLength')?.[1], getFieldValue('dateOfAdmission')))
    ) {
      return Promise.resolve();
    }
    return Promise.reject(DOADOD_INLINE_ERR_MSG);
  },
});

export const doaDodDayCareValidation = ({ getFieldValue }: any): any => ({
  validator(): any {
    const stayLength = getFieldValue('stayLength');

    if (
      !stayLength ||
      differenceInMinutes(stayLength[1], stayLength[0]) > 30
    ) {
      return Promise.resolve();
    }

    return Promise.reject(new Error(DOADOD_DAYCARE_ERR_MSG));
  },
});

export const deathCaseDODValidation = (isDeathCase: boolean): any => ({ getFieldValue }: any): any => ({
  validator(): any {
    if (isDeathCase) {
      if (moment.default(getFieldValue('dateOfDischarge')).isSameOrBefore(moment.default(), 'days')) {
        return Promise.resolve();
      }
      return Promise.reject(DEATHCASE_DOD_ERR_MSG);
    }
    return Promise.resolve();
  },
});

export const doctorNameValidation = (): any => ({
  validator: (rule: any, value: any): any => {
    if (!value || value.length > 30) {
      return Promise.reject();
    }
    if (value && !NAME_REGEX?.test(value)) {
      return Promise.reject('Please enter valid name');
    }
    return Promise.resolve();
  },
});

export const lengthOfStayValidation = (): any => ({
  validator: (rule: any, value: any): any => {
    if (value && value.length === 2) {
      const [startDate, endDate] = value;
      const diffInDays = Math.round((endDate - startDate) / (24 * 60 * 60 * 1000));
      if (diffInDays > 182) {
        return Promise.reject(LENGTHOFSTAY_INLINE_ERR_MSG);
      }
    }
    return Promise.resolve();
  },
});

export const validateRemarks = (key: string): any => ({ getFieldValue }: any): any => ({
  validator(): any {
    const fieldVal = getFieldValue(key);
    if (!fieldVal || fieldVal?.length <= 2000) {
      return Promise.resolve(); // Resolve the promise if fieldVal is empty or its length is within the limit
    }
    return Promise.reject('Remarks cannot be greater than 2000 characters long'); // Reject the promise if fieldVal length exceeds the limit
  },
});

export const billAmountGT0Validation = (key: string): any => ({ getFieldValue }: any): any => ({
  validator(): any {
    if (
      !getFieldValue(key) || getFieldValue(key) > 0 ||
      parseFloat(replaceRsAndComma(getFieldValue(key))) > 0
    ) {
      return Promise.resolve();
    }
    return Promise.reject(AMOUNT_GT_0_ERR);
  },
});

export const billMaxAmtValidation = (key: string): any => ({ getFieldValue }: any): any => ({
  validator(): any {
    if (
      !getFieldValue(key) || getFieldValue(key) > 0 ||
      parseFloat(replaceRsAndComma(getFieldValue(key))) <= 100000000
    ) {
      return Promise.resolve();
    }
    return Promise.reject(AMOUNT_MAXLIMIT_ERR);
  },
});

export const chronicDiseaseFieldValidation = (key: string): any => ({ getFieldValue }: any): any => ({
  validator(): any {
    if (
      !getFieldValue(key) || parseFloat(replaceUnderscoreAndDot(getFieldValue(key))) > 0
    ) {
      return Promise.resolve();
    }
    return Promise.reject(YEAR_0_ERR);
  },
});

export const monthValidation = (key: string, isReq: any): any => ({ getFieldValue }: any): any => ({ // function to validate month format
  async validator(): Promise<void> {
    const fieldValue = getFieldValue(key);
    if (!isReq && !fieldValue) {
      return Promise.resolve();
    }
    const isValidMonth = fieldValue?.match(VALID_MONTH_PATTERN);
    if (isValidMonth) {
      return Promise.resolve();
    } else {
      return Promise.reject(MONTH_FORMAT_ERROR);
    }
  },
});

export const yearValidation = (key: string, isReq: any): any => ({ getFieldValue }: any): any => ({ // function to validate month format
  async validator(): Promise<void> {
    const fieldValue = getFieldValue(key);
    if (!isReq && !fieldValue) {
      return Promise.resolve();
    }
    const isValidYear = fieldValue?.match(VALID_YEAR_PATTERN);
    if (isValidYear) {
      return Promise.resolve();
    } else {
      return Promise.reject(YEAR_FORMAT_ERROR);
    }
  },
});

export const settlementDodValidation = ({ getFieldValue }: any): any => ({
  validator(): any {
    if (
      !getFieldValue('stayLength')?.[1] ||
      isBefore(getFieldValue('stayLength')?.[1], new Date())) {
      return Promise.resolve();
    }
    return Promise.reject(SETTLEMENT_DOD_ERR_MSG);
  },
});

export const policyValidation = ({ getFieldValue }: any): any => ({
  validator(): any {
    if (!getFieldValue('policyNumber') || (!POLICY_NO_REGEX.test(getFieldValue('policyNumber'))
      && POLICY_NO_REGEX_SPCL_CHARACTER.test(getFieldValue('policyNumber')))) {
      return Promise.resolve();
    }
    return Promise.reject(CLAIMSUBMISSION_MESSAGE);
  },
});
export const otherPolicyValidation = ({ getFieldValue }: any): any => ({
  validator(): any {
    if (!getFieldValue('policyNumber') || POLICY_NO_REGEX_SPCL_CHARACTER.test(getFieldValue('policyNumber'))) {
      return Promise.resolve();
    }
    return Promise.reject(POLICY_SEARCH_MESSAGE);
  },
});
export const getSelectedDiagnosisIds = (selectedIds: any[], diagnosis: any[]): any[] => {
  const selectedDiagnosis = getLookUpFullDetail(selectedIds, diagnosis, true);
  return selectedDiagnosis?.map(({ payerMasterId }: any): string => payerMasterId);
};
export const getSelectedDiagnosisName = (selectedIds: any[], diagnosis: any[]): any[] => {
  const selectedDiagnosis = getLookUpFullDetail(selectedIds, diagnosis, true);
  return selectedDiagnosis?.map(({ payerMasterValue }: any): string => payerMasterValue);
};
export const getFilteredProcedureList = (array: any[], lineOfTreatmentId: any, isMapWithPLT: boolean = true): any[] => {
  return array?.filter(({ proposedLineOfTreatmentID }: any): boolean =>
    `${proposedLineOfTreatmentID}` === `${lineOfTreatmentId}`) || !isMapWithPLT ? array : [];
};

export const dialysisValidation = (limit?: any): any => ({ getFieldValue }: any): any => ({
  validator(): any {
    const maximumLimit = limit ? limit : 20;
    const fieldVal = getFieldValue('dialysis');
    if (!fieldVal || (!isNaN(fieldVal) && parseInt(fieldVal, 10) >= 1 && parseInt(fieldVal, 10) <= maximumLimit)) {
      return Promise.resolve();
    }
    if (limit) {
      if (parseInt(fieldVal, 10) < 1) {
        return Promise.reject(`Number of dialysis must be greater than 0`);
      }
      return Promise.reject(`Dialysis no. of sessions cannot be greater than the duration of hospitalization`);
    } else {
      return Promise.reject(`Number of dialysis must be in between 1-${maximumLimit}.`);
    }
  },
});
export const validateNumberInput = (key: string): any => ({ getFieldValue }: any): any => ({
  validator(): any {
    const fieldVal = getFieldValue(key);
    if (!fieldVal || (!isNaN(fieldVal) && parseInt(fieldVal, 10) >= 0 && parseInt(fieldVal, 10) <= 10)) {
      if (fieldVal?.length > 1 && fieldVal !== '10') {
        return Promise.reject(VALID_NUMBER_ERR_MSG);
      }
      return Promise.resolve();
    }

    return Promise.reject(NUMBER_INPUT_ERR_MSG);
  },
});
export const validateDynamicTreatmentDetailsForm = (key: string): any =>
  ({ getFieldValue }: any): any => {
    if (key === 'dialysis') {
      return dialysisValidation({ getFieldValue });
    }
  };

export const findAndRemoveDraft = (memberId: string, draftList: any[]): any[] => {
  const dIndex = draftList.findIndex(({ claimDetails: { memberId: mId } }: any): boolean => mId === memberId);
  draftList.splice(dIndex, 1);
  return draftList;
};

export const getTableBasedOnConfig = (config: any[] = [], mapping: any): any => {
  return config
    .filter(({ isVisible }: any): boolean => isVisible)
    .map(({ mappedComponent }: any): any => {
      return mapping[mappedComponent] || {};
    });
};

export const prepareConfigForUpload = (config: any = {}): any[] => {
  return Object.keys(config).map((key: string): any => {
    return {
      mappedComponent: key,
      isVisible: config[key],
    };
  });
};

export const prepareConfigForDisplayNameUpload = (config: Record<string, any>[] = []): Record<string, any>[] => {
  return config.map(({ mappedComponent, isVisible, displayPropName }: any): any => ({
    mappedComponent,
    isVisible,
    displayPropName,
  }));
};

export const isValidConfiguration = (formValue: any, isClaimsView?: boolean, isMaxColumnsRequired?: boolean): boolean => {
  const colLength = Object.values(formValue).filter((ele: any): boolean => ele).length;
  if (isClaimsView) {
    return (colLength >= MIN_NUMBERS_OF_CLAIMS_DISPLAY_COLS && colLength <= MAX_NUMBERS_OF_CLAIMS_DISPLAY_COLS);
  }
  return (colLength >= MIN_NUMBERS_OF_IP_COLS && (isMaxColumnsRequired ? true : colLength <= MAX_NUMBERS_OF_IP_COLS));
};

export const checkIfAnyTableSearchEnabled = (filters: any, sortingKey: any): boolean => {
  if (sortingKey?.value) {
    return true;
  } else {
    for (const key in filters) {
      if (filters[key]) {
        if (Array.isArray(filters[key])) {
          if (filters[key].length > 0 && !isBlankArray(filters[key])) {
            return true;
          }
        } else {
          return true;
        }
      }
    }
    return false;
  }
};

export const getUniqePayerIds = (arr: any[]): any[] => {
  const listOfIds: any[] = [];
  for (const { id } of arr) {
    if (!listOfIds.includes(id)) {
      listOfIds.push(id);
    }
  }
  return listOfIds;
};

export const badValueValidation = (key: string, badValues: any[]): any => ({ getFieldValue }: any): any => ({
  validator(): any {
    const fieldValueKey = Array.isArray(getFieldValue(key)); // for icici procedure value check
    const getFieldValueKey = fieldValueKey ? getFieldValue(key) : [getFieldValue(key)];
    const isValueAvailable = (getFieldValueKey || [])
      ?.filter((val: string): boolean => badValues?.includes(val?.toString()?.toLowerCase()));
    if (!isValueAvailable?.length) {
      return Promise.resolve();
    }
    return Promise.reject(
      new Error(`${isValueAvailable.join(', ')} value${isValueAvailable.length > 1 ? 's are' : ' is'} invalid.`),
    );
  },
});

export const disabledDateOfDOA = (current: any, policyStartDate: any, policyEndDate: any, doaLeftLimitValidation?: any,
  doaRightLimitValidation?: any): any => {
  return (doaLeftLimitValidation && current < moment.default().subtract(doaLeftLimitValidation, 'day')) ||
    (doaRightLimitValidation && current > moment.default().add(doaRightLimitValidation, 'day')) ||
    (policyStartDate && current < moment.default(policyStartDate)) ||
    (policyEndDate && current > moment.default(policyEndDate).add(1, 'day'));  // doa should not be greater than policy end date bugfixed
};

export const disabledDateOfDOD = (current: moment.Moment, dateOfAdmission: any, dodForValidation?: any, dodForDeath?: any): any => {
  if (dateOfAdmission && current) {
    const sixMonthsLater = moment.default(dateOfAdmission).add(6, 'months');
    return current < dateOfAdmission || (dodForValidation === 9999 && current < moment.default().startOf('day')) || current > sixMonthsLater
      || (dodForValidation && current > moment.default(dateOfAdmission).add(dodForValidation, 'day')
        || (dodForValidation && current < moment.default(dateOfAdmission)) || (dodForDeath && current > moment.default().add(1, 'day')));
  }
  return false;
};

export const isToday = (momentDate: any): boolean => {
  if (momentDate) {
    return moment.default(momentDate).isSame(moment.default().startOf('day'), 'd');
  }
  return false;
};

export const getPolicyGroup = (fieldValue: string, payerName: string): string => {
  if (fieldValue) {
    const selectedGroups = policyGroups[(payerName).toUpperCase()] || {};
    for (const key of Object.keys(selectedGroups)) {
      if (fieldValue.startsWith(key)) {
        return `${selectedGroups[key]}`;
      }
    }
  }
  return '';
};
export const getPolicyCheck = (fieldValue: string): boolean => {
  const showPolicy = POLICY_NO_REGEX.test(fieldValue);
  if (fieldValue) {
    if (showPolicy === false) {
      return false;
    }
  }
  return true;
};

export const policyWarning = (fieldValue: string): boolean => {
  const showText = POLICYNO_REGEX.test(fieldValue);
  if (fieldValue) {
    if (showText === false) {
      return false;
    }
  }
  return true;
};

const diagnosisNameMapping: any = {
  'O80': 'Delivery / Pregnancy',
  'N17': 'Dialysis',
  'H25': 'Cataract',
};

export const getDefaultDiagnosis = (array: any[]): any => {
  return array
    .filter(({ payerMasterId }: any): boolean => DEFAULT_PROD_DIAGNOSIS_ICDS.includes(payerMasterId))
    .map((ele: any): any => {
      ele.payerMasterValue = ele.name = ele.label = diagnosisNameMapping[ele.payerMasterId];
      return ele;
    })
    .concat(defaultProdDiagnosis);
};

export const getIcdCodeWithPrecedence = (icdCode: any, selectedMaternityType: any): any => {
  if (icdCode || selectedMaternityType) {
    const selectedMaternity = MATERNITY_TYPE.find((ele: any): boolean => ele.id === selectedMaternityType);
    return selectedMaternity ? selectedMaternity.code : icdCode;
  } else {
    return undefined;
  }
};

export const checkIfDelayedAdmsission = (form: any, pathname: string, isDelayJustificationEnabled: boolean,
  doaDifferenceLimit: number): boolean => {
  const { stayLength } = form.getFieldsValue(['stayLength']);
  if (
    isDelayJustificationEnabled &&
    isBefore(new Date(stayLength[0]), subDays(new Date(), doaDifferenceLimit)) &&
    getIsPageNameNewAdmission(pathname)
  ) {
    return true;
  } else {
    return false;
  }
};

export const checkEmptyObj = (remarks: any): any => {
  let flag = true;
  for (const iterator of Object.values(remarks)) {
    if (iterator) {
      flag = false;
      break;
    }
  }
  return flag;
};

export const checkIsEmptyElseReturnDefault = (arr: any[]): any => {
  const finalArr = arr.filter((ele: any): boolean => ele && ele !== null && ele !== undefined);
  return finalArr?.length ? finalArr : undefined;
};

export const isJson = (str: string): boolean => {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
};

export const doHealthIdValidation = ({ getFieldValue }: any): any => ({
  validator(): any {
    if (
      !getFieldValue('healthId') ||
      getFieldValue('healthId').match(HEALTH_ADDRESS_REGEX) ||
      getFieldValue('healthId').match(HEALTH_ID_REGEX)
    ) {
      return Promise.resolve();
    }
    return Promise.reject(HEALTH_ID_ERROR_MESSAGE);
  },
});

export const validateHealthId = (healthId: string): boolean => {
  if (healthId && (healthId.match(HEALTH_ADDRESS_REGEX) || healthId.match(HEALTH_ID_REGEX))) {
    return true;
  }
  return false;
};

export const voterIdValidation = ({ getFieldValue }: any): any => ({
  validator(): any {
    if (
      !getFieldValue('voterId') || getFieldValue('voterId').match(VOTER_ID)
    ) {
      return Promise.resolve();
    }
    return Promise.reject(VOTER_ID_ERROR_MESSAGE);
  },
});

export const panValidation = ({ getFieldValue }: any): any => ({
  validator(): any {
    if (
      !getFieldValue('kycPan') || getFieldValue('kycPan').match(PANCARD_REGEX)
    ) {
      return Promise.resolve();
    }
    return Promise.reject(PAN_CARD_NUMBER_ERROR_MESSAGE);
  },
});

export const memberIdValidation = ({ getFieldValue }: any): any => ({
  validator(): any {
    const memberID = /^\d+$/.test(getFieldValue('memberId'));
    if (!memberID && getFieldValue('memberId')) {
      return Promise.reject('Member ID must contain only numerical values.');
    } else {
      return Promise.resolve();
    }
  },
});

export const memberIdValidationNivaBupa = ({ getFieldValue }: any): any => ({
  validator: (rule: any, value: any, callback: any): any => {
    const memberIdValue = getFieldValue('memberId');
    if (memberIdValue && MEMBER_ID_NUMERICAL_REGEX.test(memberIdValue)) {
      if (memberIdValue.length >= 7) {
        callback(); // Valid member ID
      } else {
        callback('Member ID must be at least 7 digits.');
      }
    } else if (memberIdValue) {
      callback('Member ID must contain only numerical values.');
    } else {
      callback(); // Resolving for an empty value
    }
  },
});

export const patientNameValidation = ({ getFieldValue }: any): any => ({
  validator: (rule: any, value: any, callback: any): any => {
    // Check for minimum length
    if (getFieldValue('patientName')) {
      if (getFieldValue('patientName').length < 3) {
        callback('Please enter a value with a minimum of 3 characters.');
      } else {
        // Check for alphabets and spaces only
        const regex = /^[a-zA-Z\s]+$/;
        if (!regex.test(getFieldValue('patientName'))) {
          callback('Please enter only alphabets.');
        } else {
          callback();
        }
      }
    } else {
      callback(); // Resolving for an empty value
    }
  },
});
export const panValidationUpload = ({ getFieldValue }: any): any => ({
  validator(): any {
    if (
      !getFieldValue('panNumber') || getFieldValue('panNumber').match(PANCARD_REGEX)
    ) {
      return Promise.resolve();
    }
    return Promise.reject(PAN_CARD_NUMBER_ERROR_MESSAGE);
  },
});

export const panValidationUploadBill = ({ getFieldValue }: any): any => ({
  validator(): any {
    if (
      !getFieldValue('kycPanBill') || getFieldValue('kycPanBill').match(PANCARD_REGEX)
    ) {
      return Promise.resolve();
    }
    return Promise.reject(PAN_CARD_NUMBER_ERROR_MESSAGE);
  },
});

export const getAdmissionFormType = (payer: any): any => {
  let type = '';
  switch (true) {
    case (payer?.isOnMailPayer || payer?.isRPAOutboundDisabledPayer):
      type = ADMISSION_FORM_TYPES.MULTIPAYER;
      break;
    case (payer?.isCorporatePayer):
      type = ADMISSION_FORM_TYPES.CORPORATE;
      break;
    default:
      type = ADMISSION_FORM_TYPES.NORMAL;
      break;
  }
  return type;
};

export const getDetailNav = (isNewAutomationEnabled: boolean, payer: Payer): any => {
  const { isOnMailPayer, isCorporatePayer, isBenefSearchEnabled, isRPAOutboundDisabledPayer } = payer;
  if (isOnMailPayer || isCorporatePayer || isRPAOutboundDisabledPayer) {
    return [];
  } else if (isBenefSearchEnabled) {
    return isNewAutomationEnabled ? cloneDeep(NEW_DETAIL_NAV()) : cloneDeep(DETAIL_NAV());
  } else {
    return cloneDeep(NEW_DETAIL_NAV_NO_BENEF);
  }
};

export const reArrangeOptions = (
  data: any = [],
  valueProp: string,
  nameProp: string,
  options: any = {},
): any => {
  const {
    isRestRequired = false,
    additionalLabelKey = '',
    additionalLabelKeyDivider = '',
  } = options;

  if (data && data.length > 0) {
    return data.map((d: any): any => {
      const rest = isRestRequired ? d : {};
      let newLabel = d[nameProp];

      if (additionalLabelKey) {
        const additionalData =
          d[additionalLabelKey]?.length > 0
            ? `${additionalLabelKeyDivider} ${d[additionalLabelKey]}`
            : '';

        newLabel = `${newLabel} ${additionalData}`;
      }

      return {
        ...rest,
        value: d[valueProp],
        name: newLabel,
        label: newLabel,
      };
    });
  }

  return [];
};

export const DownloadExcel = (filePath: string, fileName: string): any => {
  const linkSource = `${GLOBAL_URL.REACT_APP_COMMON_BUCKET_URL}${filePath}`;
  const downloadLink = document.createElement('a');
  downloadLink.href = linkSource;
  downloadLink.download = fileName;
  document.body.appendChild(downloadLink);
  downloadLink.click();
  downloadLink.remove();
};

export const getCurrentUtcTime = (): string => moment.default().utcOffset('+05:30').format();

export const onFilterType = (inputValue: string, option: any): boolean => {
  return option?.label?.toUpperCase()?.includes(inputValue?.toUpperCase());
};

export const onFilterPayer = (inputValue: string, option: any): boolean => {
  return option?.name?.toUpperCase()?.includes(inputValue?.toUpperCase());
};
export const customGTMEvent = (dataToPush: any): void => {
  (window as any).dataLayer = (window as any).dataLayer || [];
  (window as any).dataLayer.push(dataToPush);
};

export const displayViewText = (value: boolean): any =>
  value ? 'Pre Auth View' : 'Claim View';

export const filteredObjects = (obj: any, keysToRemove: any[]): any => {
  const newObj = { ...obj };
  keysToRemove?.map((key: any): any => {
    if (newObj?.hasOwnProperty(key)) {
      delete newObj[key];
    }
  });
  return newObj;
};

export const setIsShowNow = (policyStartDate: any, policyEndDate: any): boolean => {
  const currentDate = new Date();

  if (policyEndDate <= policyStartDate) {
    return false;
  }

  const interval = { start: policyStartDate, end: policyEndDate };

  return isWithinInterval(currentDate, interval);
};

export const getFileNameWithoutExtension = (fileName: string): string => {
  const lastDotIndex = fileName.lastIndexOf('.');
  return fileName.substring(0, lastDotIndex);
};

export const getPolicyNoPattern = (policyNumber: string): boolean => {
  const firstFourChars = policyNumber?.substring(0, 4);
  if (CHOLA_POLICY_NUMBER_PATTERN?.includes(firstFourChars)) {
    return true;
  }
  return false;
};

export const getPayerConfigPropValue = (payerConfigObj: any[], propName: string, fieldName: string): any => {
  return payerConfigObj?.find((obj: any): any => obj?.label?.toLowerCase()?.replace(/_/g, '') === fieldName?.toLowerCase())?.[propName];
};

export const pehchanNoValidation = ({ getFieldValue }: any): any => ({
  validator(): any {
    const value = getFieldValue('pehchanNo');
    if (!value) {
      return Promise.resolve();
    }
    if (value.match(ALPHA_NUMERIC_REGEX) && value.length === 10) {
      return Promise.resolve();
    }
    return Promise.reject(ALPHA_NUMERIC_VALIDATION);
  },
});
export const getMappedLookUpValues = (sourceArray: any[], lookupArray: any[], key: string): any => {
  return sourceArray?.map((ele: any): any => {
    const mappedValue = findKeyValuePair(lookupArray, key, ele);
    return mappedValue !== undefined ? mappedValue?.['payerMasterValue'] : '';
  });
};

export function isEnableInitiateSettlementBtn(tpaNextStatus: string): boolean {
  if (tpaNextStatus === undefined || tpaNextStatus === '' || isEmpty(tpaNextStatus)) {
    return false;
  }
  return tpaNextStatus !== 'AWAITINGSETTLEMENT';
}
// export function flattenObject(obj: object, result: object = {}): object {
//   for (const key in obj) {
//       if (obj.hasOwnProperty(key)) {
//           if (typeof obj[key] === 'object' && obj[key] !== null) {
//               flattenObject(obj[key], result);
//           } else {
//               result[key] = obj[key];
//           }
//       }
//   }
//   return result;
// }

export const getFormattedTime = (startDate: any, endDate: any): any => {
  const parsedDate = parse(startDate, 'dd/MMM/yyyy hh:mm a', new Date());
  const parsedEndDate = parse(endDate, 'dd/MMM/yyyy hh:mm a', new Date());

  const offsetHours = 5;
  const offsetMinutes = 30;
  const adjustedDate = new Date(parsedDate?.getTime() + (offsetHours * 60 + offsetMinutes) * 60 * 1000);
  const adjustedEndDate = new Date(parsedEndDate?.getTime() + (offsetHours * 60 + offsetMinutes) * 60 * 1000);
  const formattedDate = format(adjustedDate, 'yyyy-MM-dd\'T\'HH:mm:ssxxx');
  const formattedEndDate = format(adjustedEndDate, 'yyyy-MM-dd\'T\'HH:mm:ssxxx');
  return [formattedDate, formattedEndDate];

};

const todayDate = moment.default().startOf('day');
export const dateDisabledAfterToday = (current: any): boolean => todayDate?.isBefore(moment.default(current), 'day');

export const convertToISOStrings = (dateRange: string[]): string[] | void => {
  if (isValidStayLength(dateRange)) {
    const [startDateStr, endDateStr] = dateRange;
    const startDate = new Date(startDateStr);
    const endDate = new Date(endDateStr);
    return [startDate?.toISOString(), endDate?.toISOString()];
  }
};

export const isValidStayLength = (stayLength: any): boolean => {
    return (
      Array.isArray(stayLength) &&
      stayLength?.length > 0 &&
      stayLength?.every((item: any): boolean =>
        item instanceof Date
          ? !isNaN(item.getTime())
          : item !== null && item !== undefined && item !== '' && item !== ' ',
      )
    );
};

export const checkIsLazyLoadingMaster = (masterType: string, lazyLoadMasterTypes: string): any => {
  return lazyLoadMasterTypes?.split(',')?.includes(masterType);
};

export const getTotalSizeInMB = (filesArray: any[] = [], hisFileSizeInMB?: any, avlFileSize?: any): any => {
  const totalSizeInBytes = filesArray?.reduce((sum: number, file: any): number => sum + (file?.size || 0), 0);
  const totalSizeInMB = totalSizeInBytes / (1024 * 1024);
  const hisFileSizeInMBConverted = (hisFileSizeInMB || 0) / (1024 * 1024);
  const avlFileSizeInMBConverted = (avlFileSize || 0) / (1024 * 1024);
  const combinedTotalSizeInMB = totalSizeInMB + hisFileSizeInMBConverted + avlFileSizeInMBConverted;
  const roundedSize = combinedTotalSizeInMB > 0 ? parseFloat(combinedTotalSizeInMB?.toFixed(2)) : 0;
  // Ensure that 0.00 is returned as 0
  const result = roundedSize === 0 ? '0' : `${roundedSize}`;
  return result;
};

export const getTotalFileSizeInMB = (filesArray: any): any => {
  const totalSizeInBytes = filesArray?.reduce((sum: number, file: any): any => sum + file?.size, 0);
  const totalSizeInMB = totalSizeInBytes / (1024 * 1024);
  const roundedSize = totalSizeInBytes > 0 ? parseFloat(totalSizeInMB?.toFixed(2)) : 0;
  // Ensure that 0.00 is returned as 0
  return roundedSize === 0 ? '0' : `${roundedSize}`;
};

export const getColor = (newUploads: any, totalSizeInMBs: any): string => {
  if (isNaN(newUploads)) {
    return PROGRESS_COLOR_GRAY;
  }

  return newUploads > totalSizeInMBs ? PROGRESS_COLOR_GRAY : PROGRESS_COLOR_GREEN;
};

export const getProgressColor = (newUploads: any, totalSizeInMBs: any): string => {
  const totalSize = getTotalFileSizeInMB(newUploads);
  if (isNaN(totalSize)) {
      return PROGRESS_COLOR_GRAY;
  }

  return totalSize > totalSizeInMBs ? PROGRESS_COLOR_GRAY : PROGRESS_COLOR_GREEN;
};

export const fileSizeCalculation = (sizesInBytes: number[]): string => {
  const totalSizeInBytes = sizesInBytes?.reduce((total: any, size: any): any => total + size, 0);
  const sizeInMB = totalSizeInBytes / (1024 * 1024);
  const formattedSizeInMB = sizeInMB?.toFixed(2);
  const sizeInMBString = `${formattedSizeInMB}`;
  return !isNaN(parseFloat(formattedSizeInMB)) ? sizeInMBString : '-';
};

export const getCurrentDateTime = (): string => {
  return moment?.default()?.toISOString();
};

export const containsSequentialCharacters = (password: string): boolean => {
  if (!password || password?.length < 3) {
    return false;
  }

  return Array?.from(password)?.some((_: any, i: any, arr: any): any => {
    if (i > arr?.length - 3) {
      return false; // Avoids checking past the end of the array
    }

    const currentChar = arr[i]?.charCodeAt(0);
    const nextChar = arr[i + 1]?.charCodeAt(0);
    const nextNextChar = arr[i + 2]?.charCodeAt(0);

    return (
      (nextChar === currentChar + 1 && nextNextChar === currentChar + 2) || // Ascending sequence
      (nextChar === currentChar - 1 && nextNextChar === currentChar - 2)    // Descending sequence
    );
  });
};

export const isReconsiderEnabled = (claimDetails: any, reconsiderBtnValidation: boolean, disableReconsider: boolean ): boolean => {
  const { claimFlowData } = claimDetails || {};
    if (disableReconsider) {
    // to disable button for ICICI if its artemis flow
    return false;
  }
  if (!claimFlowData?.length) {
    return true;
  }

  const { createdDate } = claimFlowData[0] || {};
  const duration = getDateDurationInHours(createdDate);
  const isReconsiderationRequestAlreadySent = claimFlowData?.some((ele: any): boolean =>
    ele?.statusId === RECONSIDERATION_REQUEST_STATUS);

  if (reconsiderBtnValidation) {
    return (duration <= 72.0 && !isReconsiderationRequestAlreadySent); // to disable reconsideration button for hdfc
    // button to be disabled after 72 hours for hdfc
  }
   return true; // for other payers
};

export const documentUploadFlow = (isPreAuthNewDesignEnabled: any, attachments: any, claimDetails: any): any => {
  return isPreAuthNewDesignEnabled
    ? !isEmpty(attachments)
      ? HIS_NEW_DESIGN_DOCUMENT_UPLOAD_FLOW
      : NON_HIS_NEW_DESIGN_DOCUMENT_UPLOAD_FLOW
    : OLD_DOCUMENT_UPLOAD_FLOW;
};

interface MappingConfig {
  path: string;
  target: string[];
}

interface HISDataToClaimFormType {
  [key: string]: MappingConfig;
}

const transformHISValueForDisplay = (target: string, hisValue: any): string | string[] => {
  if (hisValue === null) {
    return VALUE_NOT_UPDATED;
  }

  if (target === 'doctorName') {
    return typeof hisValue === 'string'
      ? PREFIXES.DOCTOR + formatDoctorName(hisValue)
      : VALUE_NOT_UPDATED;
  }

  if (target.includes('date')) {
    return formatDateValue(hisValue) || VALUE_NOT_UPDATED;
  }
  if (typeof hisValue === 'boolean') {
    return hisValue.toString();
  }
  if (Array.isArray(hisValue)) {
    if (isEmpty(hisValue)) {
      return VALUE_NOT_UPDATED;
    }
    return hisValue.every((item: Record<string, any>): boolean => item?.name || item?.value)
      ? hisValue.map((item: Record<string, any>): string => item.name || item.value)
      : VALUE_NOT_UPDATED;
  }

  if (typeof hisValue === 'object') {
    if (isEmpty(hisValue)) {
      return VALUE_NOT_UPDATED;
    }
    return hisValue?.name || hisValue?.procedure || VALUE_NOT_UPDATED;
  }

  return hisValue;
};

export const mapHISDataToFormFields = (
  hisData: Record<string, unknown>,
  mappingConfig: HISDataToClaimFormType = HISDataToClaimForm,
): Record<string, unknown> => {
  if (!hisData || typeof hisData !== 'object') {
    throw new Error('Invalid HIS data provided');
  }

  const mappedData: Record<string, unknown> = Object.create(null);
  const treatmentDetails = hisData?.treatmentDetails;

  if (treatmentDetails && !mappedData['stayLength']) {
    mappedData['stayLength'] = formatAdmissionDischargeDates(treatmentDetails);
  }

  // Use Object.entries with reduce to build mappedData in a single pass
  return Object.entries(mappingConfig).reduce((acc: Record<string, unknown>,
    [hisKey, mapping]: any): Record<string, unknown> => {
    const hisValue = get(hisData, `${mapping.path}.${hisKey}`);
    if (hisValue !== undefined) {
      // Map each target field
      mapping.target.map((target: string): void => {
        acc[target] = transformHISValueForDisplay(target, hisValue);
      });
    }
    return acc;
  }, mappedData);
};

export const formatDateValue = (dateValue: string | null): string | null => {
  if (!dateValue) {
    return null;
  }
  try {
    const date = new Date(dateValue);
    if (isNaN(date.getTime())) {
      return dateValue;  // Return original value if not a valid date
    }
    return format(date, 'dd/MMM/yyyy');
  } catch {
    return dateValue;  // Return original value if parsing fails
  }
};

export function formatAdmissionDischargeDates(treatmentDetails: any): string | null {
  if (!treatmentDetails?.dateOfAdmission && !treatmentDetails?.dateOfDischarge) {
    return VALUE_NOT_UPDATED;
  }

  const doa = formatDateValue(treatmentDetails?.dateOfAdmission);
  const dod = formatDateValue(treatmentDetails?.dateOfDischarge);

  return `DOA: ${doa}, DOD: ${dod}`;
}

export const handleUserFocus = (key: string, setInputStates: any, isFocused: boolean, hasValue?: boolean): void => {
  setInputStates((prevState: any): any => ({
    ...prevState,
    [key]: {
      isShowSuggestedValue: isFocused,
      isFocused,
      hasValue,
    },
  }));
};

export const updateInputStates = (fields: any, setInputStates: any, styleClassName?: string,
  options?: { resetFocus?: boolean; blurDomInputs?: boolean }): void => {
  setInputStates((prevStates: any): any => {
    const newStates: any = { ...prevStates };
    Object.keys(fields).forEach((key: string): any => {
      if (key in newStates) {
        newStates[key] = {
          ...newStates[key],
          ...(options?.resetFocus ? { isFocused: false } : {}),
          hasValue: !!fields[key],
        };
      }
    });
    return newStates;
  });
  if (options?.blurDomInputs) {
    const inputs = document.querySelectorAll(styleClassName || '.his-search-row-cont input');
    inputs.forEach((input: any): any => input.blur());
  }
};

export const prefillPolicyType = (hisValue: string, options: string[], form: any): void => {
  const HISPolicyType = hisValue.toLowerCase();
  const policyTypeOptions = options;
  const matchingOption = policyTypeOptions.find(
    (option: string): boolean => {
      return option.toLowerCase() === HISPolicyType;
    },
  );
  if (matchingOption) {
    form.setFieldsValue({ policyType: matchingOption });
  } else {
    form.setFieldsValue({ policyType: null });
  }
};

export const breakMessage = (message: string, maxLength: number): any => {
  if (!message) {
    return [];
  }

  const words = message?.split(' ');
  const lines: string[] = [];
  let currentLine = '';

  words?.forEach((word: any): any => {
    if ((currentLine + word)?.length <= maxLength) {
      currentLine += (currentLine ? ' ' : '') + word;
    } else {
      lines?.push(currentLine);
      currentLine = word;
    }
  });
  if (currentLine) {
    lines?.push(currentLine);
  }
  return lines;
};

// Creates a Map of field names to values from claim extension fields
const createFieldMap = (fields: any[] = []): Map<string, string> =>
  new Map(fields.map(({ fieldName, fieldValue }: { fieldName: string; fieldValue: string }): any => [fieldName, fieldValue]));

// Returns patient search parameters based on claim details and field map
const getPatientSearchParams = (
  claimDetail: any,
  fieldMap: Map<string, string>,
): HISParams => ({
  visitCode: fieldMap.get(EXTENTION_KEYS.VISIT_CODE) ?? DEFAULT_VISIT_CODE,
  visitType: fieldMap.get(EXTENTION_KEYS.VISIT_TYPE) ?? '',
  uhid: fieldMap.get(EXTENTION_KEYS.UHID) ?? '',
  ipNumber: claimDetail?.inPatientNo ?? '',
  hisPatientReferenceNumber: fieldMap.get(EXTENTION_KEYS.PATIENT_REFERENCE_NO) ?? '',
});

// Determines if patient search is allowed and returns appropriate payload
export const allowGetPatientSearch = (
  claimDetail: any,
  userId: string,
  hisId: string,
  hisProviderId: string,
): { isAllowed: boolean; payload: HISPayload } => {
  const fieldMap = createFieldMap(claimDetail?.payerClaimExtensionFields);
  const params: any = getPatientSearchParams(claimDetail, fieldMap);

  const basePayload: HISPayload = {
    loggedInUserId: userId,
    hisMasterID: hisId,
    hisProviderID: hisProviderId,
    visitCode: DEFAULT_VISIT_CODE,
    hisPatientReferenceNumber: params.hisPatientReferenceNumber,
  };
  const hisConfig = HIS_CONFIG[hisId];
  if (!hisConfig) {
    return { isAllowed: false, payload: basePayload };
  }
  // Check if all fields are non-empty when requireAll is true
  const isAllowed = hisConfig.requireAll
    ? hisConfig.optionFields.every((field: any): boolean => params?.[field] && params[field] !== '')
    : hisConfig.optionFields.some((field: any): boolean => params?.[field] && params[field] !== '');

  return {
    isAllowed,
    payload: {
      ...basePayload,
      ...hisConfig.getPayload(params),
    },
  };
};

// prevent prefilling when the value is null/undefined
export const booleanToYesNo = (value: boolean | null | undefined): 'Yes' | 'No' | undefined => {
  if (value === null || value === undefined) {
    return undefined;
  }
  return value ? 'Yes' : 'No';
};

export const formatAmount = (amount: number): string => {
  return `₹ ${amount.toLocaleString('en-IN')}`;
};

export const getBillTotal = (billDetails: any): number | null => {
  if (isEmpty(billDetails)) {
    return null;
  }

  const values = Object.values(billDetails);
  return values.every((value: unknown): boolean => value == null)
    ? null
    : values.reduce((sum: number, value: unknown): number =>
        value != null && !isNaN(Number(value)) ? sum + Number(value) : sum,
      0);
};

const findGenderMatch = (options: string[], value: string): string | undefined => {
  return options?.find(
    (gender: string): boolean  => gender?.toLowerCase() === value?.toLowerCase(),
  );
};

export const fillFormValuesFromHIS = (selectedPatientDetail: any, selectedPolicyDetail: any,
  newAdmissionSearchValues: any, memberName: string, payerLookObj: any, parsedHISFieldValues: any,
  payerConfigValues?: any, payer?: Payer): any => {
  const { patientDetails, maxID, memberName: HISMemberName, mobile, lastIPID, billDetails: HISBillDetails } = selectedPatientDetail || {};
  const { dateOfBirth: dob, memberGender, memberAge, registrationNumber, patientName, mobileNumber, inpatientNumber,
    emailId, memberId, corporateName, employeeId, policyNumber, panCardNo,
  } = patientDetails || {};
  const { treatmentAdditionalAttrs, caseDetailsAdditionalAttrs, patientDetailsAdditionalAttrs,
    dischargeDetailsAdditionalAttrs, caseDetails, dischargeInitiationDetails,
    pastHistoryAdditionalAttrs } = parsedHISFieldValues || {};
    const { dateOfSurgery, sinceWhenUnit, sinceWhen, preAuthType, eye, approach, reasonForHospitalization, systemOfMedicine,
    surgeryType, conditionOnDischarge, presentComplaints, subGroup, typeOfMaternity, noOfBiologicalChildren, noOfAdoptedChildren,
    noOfDeliveries, dateOfDelivery, lmp, routeOfAdministration, isCovidCase, admissionType, doctorQualification,
    stateMedicalCouncil, speciality, dateOfFirstDiagnosis, doctorMobileNumber, fileUploadRemarks } = treatmentAdditionalAttrs || {};
  const { injuryCausedBy, isMLC, accidentDueTo, lossType } = caseDetailsAdditionalAttrs || {};
  const { relationship, insuranceCardNumber, emergencyContactPerson, aadharNumber } = patientDetailsAdditionalAttrs || {};
  const { paidAmount, receiptNumber } = dischargeInitiationDetails || {};
  const { pastHistoryOfPresentAilment } = pastHistoryAdditionalAttrs || {};
  const { podNo, dateOfDispatch, dateOfDelivery: settlementDeliveryDate,
    courierAgencyOrPerson, handedOverTo } = dischargeDetailsAdditionalAttrs || {};
  const { isRTA } = caseDetails || {};
  const GO_DIGIT_PAYER = payerConfigValues?.some(({ options }: any): boolean => options === 'GO_DIGIT_MATERNITY_TYPE_OPTIONS') || false;
  const hospitalizationReason = DYNAMIC_FIELD_MAPPINGS[GO_DIGIT_PAYER ? 'hospitalizationReasonGoDigit' : 'hospitalizationReason'];
  const sincewhenPeriodUnit = DYNAMIC_FIELD_MAPPINGS.sinceWhenPeriod?.find(
    (unit: string): boolean => unit.toLowerCase() === sinceWhenUnit?.trim()?.toLowerCase()) || undefined;
  const sinceWhenDurationData = getValidSinceWhenDuration(sinceWhen, sincewhenPeriodUnit);
  const doctorQualificationDropDown = !isEmpty(payerLookObj?.doctorQualification)
    ? findKeyValuePair(payerLookObj?.doctorQualification, 'payerMasterValue', doctorQualification, true)?.payerMasterValue
    : prefillHISDynamicFields(doctorQualification, DYNAMIC_FIELD_MAPPINGS.doctorQualification);
  const doctorSpecialization = speciality;
  let hisAdmissionType = prefillHISDynamicFields(admissionType, DYNAMIC_FIELD_MAPPINGS.admissionType);
  const customOptionsAdmissionType = payerConfigValues?.some(({ customOptions, hidden }: any): boolean => customOptions && !hidden);
  if (customOptionsAdmissionType && !payer?.isOnMailPayer) {
    hisAdmissionType = prefillHISDynamicFields(admissionType, DYNAMIC_FIELD_MAPPINGS.admissionTypeKSRTC);
  }
  const hisLossType = prefillHISDynamicFields(lossType, DYNAMIC_FIELD_MAPPINGS.lossType);
  const billTotal = getBillTotal(HISBillDetails);
  const formValues = {
    hospitalNumber: registrationNumber || maxID,
    fullName: formatName(selectedPolicyDetail?.memberName || patientName ||
      HISMemberName || memberName),
    mobile: getMobileFormat(selectedPolicyDetail?.mobile || mobileNumber || mobile),
    inPatientNumber: inpatientNumber || lastIPID,
    emailId: selectedPolicyDetail?.memberEmailId || emailId,
    memberId: selectedPolicyDetail?.memberId || newAdmissionSearchValues?.memberId || memberId,
    employeeId: selectedPolicyDetail?.employeeCode || newAdmissionSearchValues?.employeeId || employeeId,
    corporateName: newAdmissionSearchValues?.corporateName || corporateName,
    policyNumber: selectedPolicyDetail?.policyNo || newAdmissionSearchValues?.policyNumber || policyNumber,
    memberAge,
    policyType: newAdmissionSearchValues?.policyType,
    corporateNameDropdown: newAdmissionSearchValues?.corporateNameDropdown,
    insurerName: newAdmissionSearchValues?.insurerName,
    dateOfBirth: dob && moment.default(dob).isValid() ? moment.default(dob) : undefined,
    memberGenderSexRadio: memberGender ? findGenderMatch([...GENDER_OPTIONS, ...OTHER_GENDER_OPTIONS], memberGender) : undefined,
    memberGenderSex: memberGender,
    memberGenderSelect: memberGender ? findGenderMatch(GENDER_OPTIONS, memberGender) : undefined,
    dayCareType: preAuthType,
    relation: findKeyValuePair(payerLookObj?.relation, 'payerMasterValue', relationship, true)?.payerMasterValue,
    relationTextInput: relationship,
    insuranceCardNumber,
    sinceWhenDuration: sinceWhenDurationData,
    sinceWhenPeriod: sincewhenPeriodUnit,
    eye: prefillHISDynamicFields(eye, DYNAMIC_FIELD_MAPPINGS['eye'], true),
    treatmentApproach: approach,
    cataractOperatedFor: prefillHISDynamicFields(eye, DYNAMIC_FIELD_MAPPINGS['cataractOperatedFor'], true),
    aadharNo: aadharNumber?.match(AADHAR_CARD_REGEX)?.join(' '),
    hospitalizationReason: prefillHISDynamicFields(reasonForHospitalization, hospitalizationReason),
    systemOfMedicine: prefillHISDynamicFields(systemOfMedicine, DYNAMIC_FIELD_MAPPINGS['systemOfMedicine']),
    surgeryType: prefillHISDynamicFields(surgeryType, DYNAMIC_FIELD_MAPPINGS['surgeryType']),
    conditionOnDischarge: prefillHISDynamicFields(conditionOnDischarge, DYNAMIC_FIELD_MAPPINGS['conditionOnDischarge']),
    dateOfSurgery: dateOfSurgery && moment.default(dateOfSurgery).isValid() ? moment.default(dateOfSurgery) : undefined,
    presentComplaints: isAlphabetsOnlyCheck(presentComplaints),
    reasonForInjury: prefillHISDynamicFields(injuryCausedBy, OTHER_INJURY_REASON_OPTIONS),
    accidentDueTo: prefillHISDynamicFields(accidentDueTo, DYNAMIC_FIELD_MAPPINGS['accidentDueTo']),
    isMLC: isMLC ? ['Yes'] : undefined,
    subGroup: prefillHISDynamicFields(subGroup, DYNAMIC_FIELD_MAPPINGS['subGroup']),
    typeOfMaternity,
    noOfBiologicalChildren,
    noOfAdoptedChildren,
    noOfDeliveries,
    deliveryDate: dateOfDelivery && moment.default(dateOfDelivery).isValid() ? moment.default(dateOfDelivery) : undefined,
    lmp: lmp && moment.default(lmp).isValid() ? moment.default(lmp) : undefined,
    panNumber: panCardNo,
    settlementPan: panCardNo,
    podNo,
    dateOfDispatch: dateOfDispatch && moment.default(dateOfDispatch).isValid() ? moment.default(dateOfDispatch) : undefined,
    courierAgencyName: courierAgencyOrPerson,
    handedOverTo,
    dateOfDelivery: settlementDeliveryDate && moment.default(settlementDeliveryDate).isValid() ?
      moment.default(settlementDeliveryDate) : undefined,
    patientPaidAmount: paidAmount,
    recieptNo: receiptNumber,
    switchClick: booleanToYesNo(isRTA),
    admissionType: hisAdmissionType,
    rpaAdmissionType: findKeyValuePair(payerLookObj?.admission_type, 'payerMasterValue', admissionType, true)?.payerMasterValue,
    isCovidCase: isCovidCase ? ['Yes'] : undefined,
    routeOfAdministration: findKeyValuePair(payerLookObj?.administrationRoute, 'payerMasterValue',
      routeOfAdministration, true)?.payerMasterValue,
    routeOfAdministrationText: routeOfAdministration,
    doctorQualificationDropDown,
    doctorQualification,
    stateMedicalCouncil: findKeyValuePair(payerLookObj?.stateMedicalCouncil, 'payerMasterValue',
      stateMedicalCouncil, true)?.payerMasterValue,
    stateMedicalCouncilText: stateMedicalCouncil,
    doctorSpecialization: findKeyValuePair(payerLookObj?.doctorSpecialization, 'payerMasterValue',
      doctorSpecialization, true)?.payerMasterValue,
    pastHistoryOfPresentAilment,
    memberEmergencyContactPerson: emergencyContactPerson,
    lossType: hisLossType,
    dateOfDiagnosis: dateOfFirstDiagnosis && moment.default(dateOfFirstDiagnosis).isValid() ?
      moment.default(dateOfFirstDiagnosis) : undefined,
    doctorMobileNo: doctorMobileNumber,
    fileUploadRemark: fileUploadRemarks,
    claimedAmount: billTotal?.toString(),
  };
  return formValues;
};

export const fillFormValuesFromBenef = (selectedPatientDetail: any, selectedBeneficiaryDetail: any,
  selectedPolicyDetail: any,
): any => {
  const patientDetails = selectedPatientDetail?.patientDetails;
  const memberGender = selectedBeneficiaryDetail?.memberGenderSexRadio || selectedBeneficiaryDetail?.memberGenderSex ||
  selectedBeneficiaryDetail?.memberGenderSelect || patientDetails?.memberGender;
  const formValues = {
    fullName: formatName(selectedBeneficiaryDetail?.memberName || selectedPolicyDetail?.memberName || patientDetails?.patientName),
    memberId: selectedBeneficiaryDetail?.memberId || selectedPolicyDetail?.memberId || patientDetails?.memberId,
    inPatientNumber: patientDetails?.inpatientNumber || selectedPatientDetail?.lastIPID,
    mobile: getMobileFormat(selectedBeneficiaryDetail?.mobile || selectedPolicyDetail?.mobile ||
      patientDetails?.mobileNumber || selectedPatientDetail?.mobile),
    emailId: selectedBeneficiaryDetail?.memberEmailId || selectedPolicyDetail?.memberEmailId || patientDetails?.emailId,
    employeeId: (selectedBeneficiaryDetail?.employeeCode !== '' && selectedBeneficiaryDetail?.employeeCode) ?
      selectedBeneficiaryDetail?.employeeCode :
      selectedPolicyDetail?.employeeCode || patientDetails?.employeeId,
    corporateName: selectedBeneficiaryDetail?.policyHolderName || selectedPolicyDetail?.policyHolderName ||
      patientDetails?.corporateName,
    policyNumber: selectedBeneficiaryDetail?.policyNo || selectedPolicyDetail?.policyNo || patientDetails?.policyNumber,
    memberGenderSexRadio: memberGender ? findGenderMatch([...GENDER_OPTIONS, ...OTHER_GENDER_OPTIONS], memberGender) : undefined,
    memberGenderSex: memberGender,
    memberGenderSelect: memberGender ? findGenderMatch(GENDER_OPTIONS, memberGender) : undefined,
    unitNameDropdown: selectedBeneficiaryDetail?.unitName || undefined,
  };
  return formValues;
};

 export const getButtonClassName = (isOnMailPayer: boolean, submitDisabled: boolean): any => {
  return isOnMailPayer ? 'btn-form-submit' : (submitDisabled ? 'next-btn' : 'btn-form-submit');
};

export const getButtonDisabled = (isOnMailPayer: boolean, submitDisabled: boolean, clicked: boolean): any => {
  return isOnMailPayer ? false : (submitDisabled || clicked);
};

export const getMessageForDisplay = (selectedBenefSearchOption: string, isMDI: boolean, benefForm: any): ReactElement => {
  const memberIdValue = benefForm.getFieldValue(['memberId'])?.toUpperCase();
  return selectedBenefSearchOption === BENEFICIARY_SEARCH_OPTION[0]
    ? BENEF_RETRY_MESSAGE.RETRY_MEMBER_SEARCH_WITH_POLICY
    : (isMDI && selectedBenefSearchOption === BENEFICIARY_SEARCH_OPTION_MDI[0] &&
      !memberIdValue?.startsWith(MDI_MEMBERID_PREFIX))
      ? BENEF_RETRY_MESSAGE.MDI_RETRY_MESSAGE
      : BENEF_RETRY_MESSAGE.GENERIC_RETRY_MESSAGE;
};

export const getMaxFileSizeMessage = (totalFileSizeInNumber: number): string => {
  return `Maximum total file size limit is ${totalFileSizeInNumber} MB`;
};

export const isBenefSuccess = (claimDetails: any): boolean => {
  const memberSearchField = claimDetails?.payerClaimExtensionFields
    ?.find(({ fieldName }: { fieldName: string }): boolean => fieldName === EXTENTION_KEYS.BENEF_FAILURE);

  return memberSearchField?.fieldValue === 'false';
};

export const fileCountValidation = (totalFiles: number): string => {
  return `Maximum file allowed is ${totalFiles}`;
};

export const hasReplyStatus = (record: any, statusId: number): boolean =>
  record?.allowStatus?.some((status: any): boolean => status.statusId === statusId);

export const handleRemoveFile = (fileToRemove: UploadFile<any>, setFileList: any,
  fileListRef: React.MutableRefObject<UploadFile<any>[]>): void => {
  setFileList((prevList: any[]): any[] => {
    const filteredList = prevList?.filter((file: any): boolean => file.uid !== fileToRemove.uid);
    fileListRef.current = filteredList;
    return filteredList;
  });
};

const FIELD_VALIDATION_MESSAGES: Record<string, string> = {
  required: '{fieldName} is required!',
  pattern: '{fieldName} is invalid',
  type: '{fieldName} is not valid!',
  min: '{fieldName} must be at least {min} characters',
  max: '{fieldName} cannot be longer than {max} characters',
};

interface ValidationRule {
  validator?: (...args: any[]) => Promise<void> | void;
  message?: string;
  [key: string]: any;
}
export const withFieldName = (rule: ValidationRule, fieldDisplayName: string): ValidationRule => {
  // Handle existing message with ${label} placeholder
  if (rule?.message && typeof rule.message === 'string' && rule.message.includes('${label}')) {
    return {
      ...rule,
      message: rule.message.replace(/\$\{label\}/g, fieldDisplayName),
    };
  }
  // Find matching rule type in our message templates
  const ruleType = Object.keys(FIELD_VALIDATION_MESSAGES).find((key: string): boolean => rule[key] !== undefined);
  if (!ruleType) {
    return rule;
  }
  // Get the message template and replace the fieldName placeholder
  let message = FIELD_VALIDATION_MESSAGES[ruleType].replace('{fieldName}', fieldDisplayName);
  // Replace dynamic values if present
  if (['min', 'max'].includes(ruleType)) {
    message = message.replace(`{${ruleType}}`, rule[ruleType]);
  }

  return {
    ...rule,
    message,
  };
};

export const getDoctorWithSignature = (selectedDoctorList: any, doctorList: Doctor[], form: FormInstance): string => {
  // If selectedDoctorList is available, check for the signature of the selected doctor
  if (!isEmpty(selectedDoctorList)) {
    const matchedDoctor = doctorList?.find((doctor: Doctor): boolean => {
      return doctor?.value === selectedDoctorList?.value;
    });
    if (matchedDoctor?.signature) {
      // Return signature if found for the selected doctor
      return matchedDoctor.signature;
    }
  }

  // If selectedDoctorList is not available or no signature found, check default doctors
  const defaultDoctorsWithSignature = doctorList
    ?.filter((doctor: any): boolean =>
      doctor?.name?.toLowerCase()?.startsWith(DEFAULT_TEXT) && doctor?.signature,
    ) || [];
  // If there are any default doctors with a signature, pick one randomly
  if (!isEmpty(defaultDoctorsWithSignature) && form?.getFieldsValue()?.doctorName) {
    const randomDoctor = defaultDoctorsWithSignature[Math.floor(Math.random() * defaultDoctorsWithSignature.length)];
    return randomDoctor?.signature || ''; // Return the signature or an empty string if not found
  }

  // If no signature found, return null
  return '';
};

export const validateDateRange = (_: any, value: any): Promise<any> => {
  // Skip validation if no dates are entered or invalid format
  if (!Array.isArray(value) || isEmpty(value)) {
    return Promise.resolve();
  }

  // Only validate if one date is present but not the other
  const [doa, dod] = value;
  if ((doa && !dod) || (!doa && dod)) {
    return Promise.reject(new Error(DATEPICKER_ERROR_MESSAGE));
  }

  return Promise.resolve();
};

export const validateEmailField = (_: any, value: string): Promise<void> => {
  if (!value) {
    return Promise.resolve();
  }

  const { emailIdValidation, emailIdCharLimit, invalidAndTooLongEmail } = CONFIGURATION_VALIDATIONS;
  const isInvalidFormat = !EMAIL_REGX.test(value);
  const isTooLong = value?.length > 50;

  if (isInvalidFormat && isTooLong) {
    return Promise.reject(invalidAndTooLongEmail);
  }

  if (isInvalidFormat) {
    return Promise.reject(emailIdValidation);
  }

  if (isTooLong) {
    return Promise.reject(emailIdCharLimit);
  }

  return Promise.resolve();
};

export const bytesToMB = (sizeInBytes: number): string => {
  const sizeInMB = sizeInBytes / (1024 * 1024);
  const formattedSizeInMB = sizeInMB?.toFixed(3);
  const parsedSize = parseFloat(formattedSizeInMB);
  return !isNaN(parsedSize) ? `${formattedSizeInMB} MB` : '-';
};

export const formatDateAndTime = (
  date: Date | string | null | undefined,
  condition: boolean,
): { formattedDate: string; formattedTime: string } => {
  if (!condition || !date) {
    return { formattedDate: '', formattedTime: '' };
  }

  const parsedDate = typeof date === 'string' ? new Date(date) : date;

  const formattedDate = parsedDate.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  }).replace(',', '');

  const formattedTime = parsedDate.toLocaleTimeString('en-GB', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  }).replace(':', '.');

  return { formattedDate, formattedTime };
};

export const clearFormFieldsByQuestionText = (
  form: FormInstance,
  classificationArr: any[],
): void => {
  classificationArr?.forEach((item: ClassificationItem): void => {
    const fieldName = item.questionText;
    const fieldValue = item.questionType;
    const value = form.getFieldValue(fieldName);
    // when the field value is not present as yes clearing the field values
    if (value !== undefined) {
      form.setFieldsValue({ [fieldName]: undefined });
      form.setFieldsValue({ [fieldValue]: undefined });
      item.isSelectFile = false;
    }
  });
};

export const uploadStyledSignature = async (name: string, fontSize: string, fontFamily: string): Promise<void> => {
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');
  const patientName = name?.length;
  const fontSizeValue = patientName > 18 ? '33px' : '45px';

  if (!ctx) {
    return;
  }
  canvas.width =
    patientName >= 26 && patientName <= 50 ? 1000 :
      patientName >= 12 && patientName <= 25 ? 500 :
        400;
  canvas.height = 100;

    await document.fonts.load(`${fontSizeValue} ${fontFamily}`);
    await document.fonts.ready;

  ctx.fillStyle = '#fff';
  ctx.fillRect(0, 0, canvas.width, canvas.height);

  ctx.font = `${fontSizeValue} ${fontFamily}`;
  ctx.fillStyle = '#000';
  ctx.textAlign = 'center';
  ctx.textBaseline = 'middle';
  ctx.fillText(name, canvas.width / 2, canvas.height / 2);
  // Convert to base64
  const base64Image = canvas.toDataURL('image/png');
  uploadSignatureImage(base64Image);
};

export const uploadSignatureImage = async (base64Image: string): Promise<any> => {
  try {
    // Convert base64 to Blob
    const byteString = atob(base64Image?.split(',')[1]);
    const mimeString = base64Image?.split(',')[0]?.split(':')[1]?.split(';')[0];

    const binaryBufferData = new ArrayBuffer(byteString?.length);
    const binaryDataView = new Uint8Array(binaryBufferData);
    binaryDataView?.set(byteString?.split('')?.map((c: string): number => c?.charCodeAt?.(0)));

    const blob = new Blob([binaryBufferData], { type: mimeString });
    const file = new File([blob], CASHLESS_FORM_CONSTANTS.SIGNATURE, { type: mimeString });
    const formData = new FormData();
    formData.append('file', file);
    formData.append('FileUploadType', INVENTROY_CONSTANTS.patient_signature);
    formData.append('ApplicationId', APPLICATION_ID_2);
    const response = await fetch(process.env.REACT_APP_BASE_URL + 'File/Upload', {
      method: 'POST',
      // headers: {
      //   accessToken: ApplicationDetail.instance.getAccessToken(),
      // },
      credentials: 'include',
      body: formData,
    });
    const result = await response.json();
    const patientSignGuid = result?.fileUploadDetails?.[0]?.fileGuid;
    const fileModifiedOn = new Date()?.toISOString();
    const patientSign = { guid: patientSignGuid, modifiedOn: fileModifiedOn };
    localStorage?.setItem(INVENTROY_CONSTANTS.patient_signature, JSON?.stringify(patientSign));
  } catch (error) {
    centeredNotification('Upload failed', 'error');
  }
};

export const getSignatureOnChangeMemberName = (value: string, patientConsentProceedClicked: boolean,
  consentOption: string, consentFontSize: string, consentFontFamily: string): void => {
  if (value && patientConsentProceedClicked && consentOption === PATIENT_SIGNATURE_CONSTANTS.PATIENT_SIGNATURE_OPTIONS[1]) {
    uploadStyledSignature(value, consentFontSize, consentFontFamily);
  }
};

export const stringToArray = (str: string, separator: string = ','): string[] => {
  if (!str) {
    return [];
  }
  return str.split(separator).map((item: string): string => item.trim()).filter(Boolean);
};

// to map HIS treatmentDetails for email payers
export const processHISData = (
  HISData: any,
): string[] => {

  if (!HISData) {
    return [];
  }
  if (typeof HISData === 'string') {
    return stringToArray(HISData, ',');
  }
  if (Array.isArray(HISData)) {
    return HISData.map((item: Record<string, any>): string => item?.name?.trim())?.filter(Boolean);
  }
  return [];
};
export const updateHISAdmissionFormValue = ({ patientDetails, doctorDetails, caseDetails,
  treatmentDetails, treatmentPastHistory }:
  any, formVal: AdmissionForm, { isOnMailPayer }: Payer ): AdmissionForm => {
  const [customerKey, treatmentKey] = NEW_ADMISSION_FORM_KEY;
  const mobileNumber = patientDetails?.mobileNumber;
  const formattedNumber = mobileNumber ? `+91 ${mobileNumber.slice(0, 3)} ${mobileNumber.slice(3, 7)} ${mobileNumber.slice(7)}` : '';
  const fullName = patientDetails?.patientName;
  const inPatientNumber = patientDetails?.inpatientNumber;
  const admissionDate = treatmentDetails?.dateOfAdmission;
  const dischargeDate = treatmentDetails?.dateOfDischarge;
  let HISStayLength: any[] = [admissionDate, dischargeDate];
  if (admissionDate && dischargeDate) {
    const admissionDateTime = new Date(admissionDate);
    const dischargeDateTime = new Date(dischargeDate);
    const timeDifferenceInMinutes = differenceInMinutes(dischargeDateTime, admissionDateTime);
    if (timeDifferenceInMinutes <= 30) {
      HISStayLength = [admissionDate, null];
    }
  }
  const HISDiagnosis = treatmentDetails?.diagnosis;
  const HISProcedure = treatmentDetails?.procedure;
  const procedureArray = processHISData(HISProcedure);
  const diagnosisArray = processHISData(HISDiagnosis);
  const { doctorName } = doctorDetails || {};
  const HISDoctorName = typeof(doctorName) === 'string' ? formatDoctorName(doctorName) : null;

  if (!isOnMailPayer) {
    const newCustomerDetail = {
      fullName,
      memberAge: patientDetails?.memberAge,
      mobile: formattedNumber,
      inPatientNumber,
      // TODO: Don't remove emailId. Cause of multiple email issue. Comment the line.
      // emailId,
    };
    const newTreatmentDetail: any = {
      stayLength: HISStayLength,
      doctorName: HISDoctorName,
      doctorRegNo: doctorDetails?.doctorRegistrationNo,
      isDischargeCase: doctorDetails?.isDischargedToday ? ['Yes'] : undefined,
      isDeathCase: doctorDetails?.isDeath ? ['Yes'] : undefined,
      isItARta: caseDetails?.isRTA,
      injuryOrDeseaseCaused: caseDetails?.isSubstanceAbuse,
      testConductedToEstablishedThis: caseDetails?.isTestConducted,
      isReportedToPolice: caseDetails?.isReportToPolice,
      firNumber: caseDetails?.firNumber,
      otherAilment: treatmentPastHistory?.otherAilments,
      dateOfInjury: caseDetails?.dateOfInjury ? moment.default(caseDetails?.dateOfInjury) : null,
    };
    const customerDetail = { ...(formVal as any)[customerKey], ...newCustomerDetail };
    const treatmentDetail = { ...(formVal as any)[treatmentKey], ...newTreatmentDetail };
    return { ...formVal, ...{ customerDetail }, ...{ treatmentDetail } };
  } else {
    const customerDetail = {
      doctorName: HISDoctorName,
      doctorRegNo: doctorDetails?.doctorRegistrationNo,
      stayLength: HISStayLength,
      diagnosis: diagnosisArray,
      procedure: procedureArray,
    };
    return { ...formVal, ...{ customerDetail } };
  }
};

export const getDraftKeyFromStatus = (
  nextAllowStatus: string[] | undefined,
  statusToIndexMap: { [key: string]: number },
  draftSequence: DraftItem[],
  isDischargeContestCTA: boolean,
): string | undefined => {
  const statusKey = nextAllowStatus?.[0];

  if (statusKey === 'DISCHARGE' && isDischargeContestCTA) {
    return draftSequence.find(({ key }: DraftItem): boolean => key === DRAFT_KEYS.dischargeContest)?.key;
  }

  const index = statusToIndexMap[statusKey ?? ''] ?? 0;
  return draftSequence[index]?.key;
};

export const isRemarksFieldRequired = (key: string, formControlConfig: Record<string, any>, isCancel: boolean,
  nextStatus: string, isDischargeContestCTA: boolean): boolean => {
  const fieldObj = formControlConfig[key];
  return fieldObj?.requiredFor?.includes(isCancel ? ctaActionNames.CANCELLATION : nextStatus === 'DISCHARGE' &&
    isDischargeContestCTA ? ctaActionNames.DISCHARGE_CONTEST_ACTION : nextStatus);
};

export const getLettersFromPatientDetails = (selectedPatientDetail: PatientDetail, hospitalSearchPatientDetails: any[]): Letter[] => {
  if (!isEmpty(selectedPatientDetail?.letters)) {
    return selectedPatientDetail.letters ?? [];
  }

  if (!isEmpty(hospitalSearchPatientDetails?.[0]?.letters)) {
    return hospitalSearchPatientDetails[0].letters ?? [];
  }

  return [];
};

export const formatDocumentUploadedDate = (dateString: string, isSortFiles: boolean = false): string => {
  const parsedDate = DATE_FORMAT_TO_PARSE.map((dateFormat: string): Date => parse(dateString, dateFormat, new Date()))
    ?.find((parsed: Date): boolean => isValid(parsed));
  if (parsedDate) {
    return format(parsedDate, isSortFiles ? DATE_FORMAT_TO_PARSE[0] : DATE_FORMAT_TO_PARSE[1]);
  }
  return getDateWithTime(new Date());
};

export const sortOnDate = (arr: any[] = [], sortingKeys: string[]): any[] => {
  const sortedArray = [...arr]?.sort((a: any, b: any): number => {
    const dateStrA = a?.[sortingKeys[0]] || a?.[sortingKeys[1]];
    const dateStrB = b?.[sortingKeys[0]] || b?.[sortingKeys[1]];

    const dateA = new Date(formatDocumentUploadedDate(dateStrA, true));
    const dateB = new Date(formatDocumentUploadedDate(dateStrB, true));
    return dateB?.getTime() - dateA?.getTime();
  });
  return sortedArray;
};

export const shouldSkipPrefillPayer = (
  payerDetail: Payer | undefined,
  configuredPayers: Payer[],
): boolean => {
  if (!payerDetail) {
    return false;
  }
  // Check if there is a direct payer with the same short name but NOT an RPA or Mail payer
  const hasDirectPayer = configuredPayers.some(
    (payerItem: Payer): boolean =>
      payerItem.shortName === payerDetail.shortName &&
      (!payerItem.isRpaPayer &&
        !payerItem.isOnMailPayer),
  );
  // Skip prefill if:
  // - The selected payer is an RPA payer or a Mail payer
  // - AND a direct payer with the same short name exists
  return (!!payerDetail.isRpaPayer || !!payerDetail.isOnMailPayer) && hasDirectPayer;
};

export const updatePayerNameFromHIS = (patientDetails: any, isDraftSelected: boolean,
  setpayerNameFromHIS: any, isOldNADesign: boolean, payerDetail?: Payer | undefined): void => {
  if (!isOldNADesign) {
    if (!isEmpty(patientDetails) && payerDetail && !isDraftSelected) {
      setpayerNameFromHIS(payerDetail?.name);
    } else if (!isEmpty(patientDetails)) {
      setpayerNameFromHIS(VALUE_NOT_UPDATED);
    }
  }
};

export const prefillPayer = (
  selectedPayerId: number | string | null,
  configuredPayers: Payer[],
  payers: PayerConfig[],
  isDraftSelected: boolean,
  dispatch: any,
  baseForm: FormInstance,
  isOldNADesign: boolean,
  initiateMemberForm: any,
  changePayer: any,
  patientDetails: any,
  setIsShowAdmissionForm: any,
  setpayerNameFromHIS?: any,
): void => {
  if (selectedPayerId) {
    const payerDetail: Payer | undefined = configuredPayers.find(
      ({ uniqueIdentifier: identifier }: Payer): boolean => identifier === String(selectedPayerId),
    );
    // If the selected payer is an RPA payer or a mail payer AND a direct payer with the same short name exists, skip prefill
    if (payerDetail && !isDraftSelected && !shouldSkipPrefillPayer(payerDetail, configuredPayers)) {
      dispatch(setIsShowAdmissionForm(false));
      dispatch(changePayer(payerDetail));
      const selectedPayer = payers?.find(
        (item: PayerConfig): boolean => payerDetail?.id === item['payerID'],
      );
      if (payerDetail.isRpaPayer && (selectedPayer && selectedPayer?.isEnabled === false)) {
        centeredNotification(PAYER_NOT_CONFIGURED_ERR);
      }
      baseForm.setFieldsValue({ payer: payerDetail?.name });
    }
    updatePayerNameFromHIS(patientDetails, isDraftSelected, setpayerNameFromHIS, isOldNADesign, payerDetail);
    if (isOldNADesign) {
      initiateMemberForm();
    }
    return;
  }
  updatePayerNameFromHIS(patientDetails, isDraftSelected, setpayerNameFromHIS, isOldNADesign);
};

// Getting extension Field value based on key
export const getExtensionFieldsValue = (fieldName: string, fields: any[]): string | undefined => {
  return fields?.find((field: ExtensionField): boolean => field.fieldName === fieldName)?.fieldValue;
};

export const shouldShowDayCareTag = (
  isDetailPage: boolean,
  payerClaimExtensionFields: any[],
  isDaycareCase: boolean,
  claimDetails: any,
  stayLength: any,
  showDayCareInDraftFlow: boolean,
  isDraftBtnClicked: boolean,
): boolean => {
  // true - when isDaycareCase is true or if its detail page and dayCareType extension data is present
  const { doa, dod } = claimDetails || {};
  let daysDifference = 0;
  const isValidDayCare = isDaycareCase && isValidStayLength(stayLength);
  if (doa && dod) {
    const admitDateTime = new Date(doa);
    const dischargeDateTime = new Date(dod);
    if (!isNaN(admitDateTime.getTime()) && !isNaN(dischargeDateTime.getTime())) {
      // Time difference
      const minutesDifference = differenceInMinutes(dischargeDateTime, admitDateTime);
      daysDifference = Math.ceil(minutesDifference / (24 * 60));
    } else {
      daysDifference = 0;
    }
  }
  // Show the Day Care tag if:
  // 1. It's a valid day care case (daycare flag is true and stay length is valid)
  // 2. OR it's the detail page, and the stay is 1 day or less, and the day care type extension is present
  // 3. OR it's a draft flow with a valid day care case
  return (
    ((isValidDayCare && !isDraftBtnClicked) ||
    ((isDetailPage && daysDifference <= 1) &&
      !!getExtensionFieldsValue(EXTENTION_KEYS.DAY_CARE_TYPE, payerClaimExtensionFields) ||
      (showDayCareInDraftFlow && isValidDayCare)))
  );
};

export const isInitialDischargeEnabled = (
  isInitialDischargeEnabledProvider: boolean,
  isDaycareCase: boolean | undefined,
  isInitialDischargeEnabledPayer: boolean | undefined,
): boolean => {
  return (
    !!isInitialDischargeEnabledProvider &&
    !!isDaycareCase &&
    !!isInitialDischargeEnabledPayer
  );
};

export const getProviderFeatureFlags = (providerFeatures: any, key: string): boolean => {
  return providerFeatures?.[key];
};

export const shouldShowDayCareInDraftFlow = (
  draftKey: string,
  draftKeywords: string[],
): boolean => {
  return draftKeywords?.some((keyword: string): boolean => draftKey?.includes(keyword));
};

export const getExactDoctorMatch = (doctorList: any[], doctorName: string, doctorRegNo: string): boolean => {
  // function to check exact match if the entered RegNo is in the doctor List
  const isExactDoctorMatch = doctorList?.some((doc: any): boolean => (doc?.registrationNo === doctorRegNo
    && doc?.name?.toLowerCase()?.trim() === doctorName?.toLowerCase()?.trim()));
  return isExactDoctorMatch;
};

export function filterBeneficiaries(
  shouldFilter: boolean,
  selectedOption: string,
  benefList: BeneficiaryDetail[],
  failedBeneficiarySearch: any,
): BeneficiaryDetail[] {
  if (shouldFilter && (selectedOption === BENEFICIARY_SEARCH_OPTION_MDI[1]) && benefList?.length > 1) {
    const filteredBenefList =  benefList?.filter((benef: BeneficiaryDetail): boolean => (benef?.percentageNameMatch >= 60));
    if (filteredBenefList.length === 0) { // to open form incase there are no cards after filteration
      failedBeneficiarySearch(BENEF_NOT_FOUND_MESSAGE, null, true);
    }
    return filteredBenefList;
  }
  return benefList;
}

export const getPrimarySearchKey = (searchType: string): string => {
  return BENEF_PRIMARY_KEY_MAP[searchType] || '';
};

export const getNestedValue = (patientData: Record<string, any>, possiblePaths: string[]): any => {
  for (const path of possiblePaths) {
    const value = path.split('.').reduce((currentObject: Record<string, any>, propertyName: string): any => {
      return currentObject ? currentObject[propertyName] : undefined;
    }, patientData);

    if (value !== undefined) {
      return value;
    }
  }
  return null;
};

export const objectArrayToString = (obj: any[]): string => {
  return !isEmpty(obj) ? obj.map((objValue: Record<string, any>): string => objValue.name).join(', ') : '-';
};

export const getCancelModalTitle = (
  cancelActionProperty: any,
  fallbackTitle: string,
): string => {
  return cancelActionProperty?.ModelName ?? fallbackTitle;
};

export const getCancellationMessage = (
  notificationType: string,
  actionProperties: any,
  cancelActionProperty: any,
  errorMessage?: string,
): string => {
  if (notificationType === 'success') {
    return isEmpty(actionProperties)
      ? CANCELLATION_SUCCESSFUL_MESSAGE
      : cancelActionProperty?.ActionMessage || CANCELLATION_SUCCESSFUL_MESSAGE;
  }
  return errorMessage || CANCELLATION_FAILURE_MESSAGE;
};

export const getFlowSpecificRemarkLength = (config: any, flowName: string): number | undefined => {
  if (config && config[flowName]) {
    return config[flowName];
  }
  return undefined;
};

export const getIHave  = (HISBenefSearchPayload: Record<string, any>, iHaveOptions: string[]): string => {
  for (const [payloadKey, value] of Object.entries(HISBenefSearchPayload)) {
    if (value && PAYLOAD_TO_IHAVE[payloadKey]) {
      // Find the matching iHave value from available search options
      const possibleIHaveValues = PAYLOAD_TO_IHAVE[payloadKey];

      for (const possibleValue of possibleIHaveValues) {
        if (iHaveOptions.includes(possibleValue)) {
          return possibleValue;
        }
      }
    }
  }

  // If no match found, return the first available search option as default
  return !isEmpty(iHaveOptions) ? iHaveOptions[0] : '';
};

export const formatDoctorName = (doctorName: string): string => {

  // Trim whitespace and check if empty
  const trimmedName = doctorName.trim();
  if (!trimmedName) {
    return '';
  }
  // handles variations like "Dr.", "Dr ", "DR.", "dr.", etc.
  const formatted = trimmedName.replace(DOCTOR_NAME_REGEX, '').trim();
  return formatted || '';
};

export const findPLTByName = (options: any[], searchName: string): Record<string, any> | undefined => {
  if (isEmpty(options)) {
    return undefined;
  }
  return options.find((option: any): boolean => {
    const optionName = option?.name?.toLowerCase();
    const searchNameLower = searchName.toLowerCase();
    if (!optionName || !searchNameLower) {
      return false;
    }
    return searchNameLower.includes(optionName) || optionName.includes(searchNameLower);
  });
};

export const getPLTValue = (lineOfTreatment: any, pltOptions: any[]): string | undefined => {
  if (!pltOptions?.length) {
    return undefined;
  }

  // Handle string input
  if (typeof lineOfTreatment === 'string') {
    const foundOptionValue = findPLTByName(pltOptions, lineOfTreatment);
    return foundOptionValue?.value;
  }

  // Handle object input
  if (typeof lineOfTreatment === 'object' && !isEmpty(lineOfTreatment)) {
    const { id: lineOfTreatmentId, name: HISpltName } = lineOfTreatment || {};

    // Try to find by ID first
    if (lineOfTreatmentId) {
      const foundOption = findKeyValuePair(pltOptions, 'value', lineOfTreatmentId);
      if (foundOption) {
        return foundOption.value;
      }
    }

    // Fallback to name matching if option not found by ID
    if (HISpltName) {
      const foundOptionByName = findPLTByName(pltOptions, HISpltName);
      return foundOptionByName?.value;
    }
  }

  return undefined;
};

export const findSelectedPayer = (configuredPayersList: any, uniquePayerId: string): Payer => {
  return configuredPayersList.find(
    ({ uniqueIdentifier }: any): boolean => uniqueIdentifier === uniquePayerId.trim(),
  );
};

export const createBillPackageIndexMap = (formbillDetail: { billPackageName: string }[]): Record<string, number> => {
  return formbillDetail.reduce((map: Record<string, number>,
    item: { billPackageName: string }, idx: number): Record<string, number> => {
    map[item.billPackageName] = idx;
    return map;
  }, {});
};

// Disable fields in the form that are prefilled with HIS data
export const disableHISPopulatedFields = (indicesToDisable: Set<number>, setBillDetail: any): void => {
  setBillDetail((prev: BillItem[]): BillItem[] =>
    prev.map((item: BillItem, idx: number): BillItem =>
      indicesToDisable.has(idx) ? { ...item, disabled: true } : item,
    ),
  );
};

export const processHISBillData = (billDetailsFromHIS: any, fieldIndexMap: Record<string, number>,
  BillDetailsFieldsMap: Record<string, string[]>): {
  updateBillDetails: Record<string, any>;
  indicesToDisable: Set<number>;
} => {
  const updateBillDetails: Record<string, any> = {};
  const indicesToDisable = new Set<number>();

  for (const [key, value] of Object.entries(billDetailsFromHIS)) {
    // Skip empty values or keys not in our mapping
    if (!value || !(key in BillDetailsFieldsMap)) {
      continue;
    }

    // Find corresponding form fields to update them
    for (const fieldName of BillDetailsFieldsMap[key as keyof typeof BillDetailsFieldsMap]) {
      const index = fieldIndexMap[fieldName];
      if (index !== undefined) {
        updateBillDetails[fieldName] = value.toString();
        indicesToDisable.add(index);
      }
    }
  }

  return { updateBillDetails, indicesToDisable };
};

export const setPanFieldInBuddhimedFromHIS = (
  patientDetails: any,
  optionalReq: boolean,
  form: any,
  dispatch: any,
  setPanField: any,
): void => {
  if (!isEmpty(patientDetails) && optionalReq) {
    const panCardNoFromHIS = patientDetails?.panCardNo;
    if (panCardNoFromHIS) {
      form.setFields([{
        name: 'panNumber',
        value: panCardNoFromHIS,
      }]);
      dispatch(setPanField(panCardNoFromHIS));
    }
  }
};

export const getValidSinceWhenDuration = (
  sinceWhen: string | undefined,
  sinceWhenUnit: string | undefined,
): string | undefined => {
  if (!sinceWhenUnit) {
    return undefined;
  }
  const isValidData = sinceWhenUnit?.trim() !== '' && sinceWhen && !SINCE_WHEN_NUMBERS_AND_SPACES_REGEX.test(sinceWhen);
  return isValidData ? sinceWhen : undefined;
};

export const parseValueByType = (value: any, type: HISPrefillParseType): HISPrefillParseType => {
  if (type === 'boolean') {
    return value === 'true' || value === true;
  }
  if (type === 'date') {
    return new Date(value);
  }
  if (type === 'number') {
    return Number(value);
  }
  return value; // string or fallback
};

// Removes special characters and extra spaces, allowing only alphabets and single spaces.
export const isAlphabetsOnlyCheck = (value?: string): string =>
  (value ?? '')?.replace(ONLY_ALPHABET, '') // remove special chars
    .replace(/\s{2,}/g, ' ') // collapse multiple spaces
    .trim();

export const getParsedAttributesObject = (fieldKeyAttributes: Record<string, any>): Record<string, any> => {
  if (!fieldKeyAttributes || typeof fieldKeyAttributes !== 'object') {
    return {};
  }

  const parsedObj = Object?.entries(fieldKeyAttributes)?.reduce((acc: Record<string, unknown>,
    [key, value]: any): Record<string, unknown> => {
    const expectedType = (HIS_ADDITIONAL_ATTRIBUTES_MAP_TYPE as any)[key] || 'string';
    acc[key] = parseValueByType(value, expectedType);
    return acc;
  }, {} as Record<string, any>);
  return parsedObj;
};

export const prefillHISDynamicFields = (hisValue: string, options: string[], partialMatch?: boolean): string | undefined => {
  const HISValues = hisValue?.toLowerCase();
  const matchingOption = options?.find(
    (option: string): boolean => partialMatch ? option.toLowerCase().includes(HISValues) : option.toLowerCase() === HISValues,
  );
  return matchingOption;
};

export const getInsurerDetails = (insurerID: string, payerLookObj: any): string | undefined => {
  return findKeyValuePair(payerLookObj?.insurerName, 'payerMasterId', insurerID)?.payerMasterValue || undefined;
};

export const shouldShowReasonForEnhancement = (fieldRequired: boolean, editPage: boolean, isDraft: boolean, draftKey: string,
  detailPage: boolean, statusOfClaim: number): boolean => {
  // it returns true if that field is required for that specific payer, If it is enhancement or a draft of enhancement and
  // only detail page of a enhancement claim
  return fieldRequired && (editPage || (detailPage && statusOfClaim === 3) || (isDraft && draftKey === DRAFT_KEYS.enhance));
};

export const shouldShowReasonForReconsideration = (fieldRequired: boolean, reconsiderPage: boolean, isDraft: boolean, draftKey: string,
  detailPage: boolean, statusOfClaim: number): boolean => {
  // it returns true if that field is required for that specific payer, If it is reconsider or a draft of reconsider
  // and only detail page of a reconsider claim
  return fieldRequired && (reconsiderPage || (detailPage && statusOfClaim === 53) || (isDraft && draftKey === DRAFT_KEYS.reconsider));
};

export const invalidFileTypeErrorMessage = (value: string): string => {
  return `Invalid file format. Please upload only ${value} file.`;
};

export const getProductCode = (isOrionIntegrationEnabledPayerProvider: boolean, isArtemis: boolean): string | undefined => {
  return (isOrionIntegrationEnabledPayerProvider ? (isArtemis) ?
  ORION_PRODUCT_CODE_ARTEMIS : ORION_PRODUCT_CODE_FT : undefined);
};
